!(function ($) {
  var $ = (jQuery = $),
    cc = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function e(t) {
      t.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        }
      );
    },
    unload: function e(t) {
      t.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function e(t) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            $.post(
              theme.routes.cart_url + "/update.js",
              { note: t },
              function (e) {},
              "json"
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval
        ));
    },
  }),
    (theme.Shopify = {
      formatMoney: function e(t, i) {
        function a(e, t) {
          return void 0 === e ? t : e;
        }
        function n(e, t, i, n) {
          if (
            ((t = a(t, 2)),
            (i = a(i, ",")),
            (n = a(n, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          var o = (e = (e / 100).toFixed(t)).split(".");
          return (
            o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
            (o[1] ? n + o[1] : "")
          );
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var o = "",
          s = /\{\{\s*(\w+)\s*\}\}/,
          r = i || this.money_format;
        switch (r.match(s)[1]) {
          case "amount":
            o = n(t, 2);
            break;
          case "amount_no_decimals":
            o = n(t, 0);
            break;
          case "amount_with_comma_separator":
            o = n(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            o = n(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            o = n(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = n(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = n(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            o = n(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            o = n(t, 2, ".", ".");
        }
        return r.replace(s, o);
      },
      formatImage: function e(t, i) {
        return t ? t.replace(/^(.*)\.([^\.]*)$/g, "$1_" + i + ".$2") : "";
      },
      Image: {
        imageSize: function e(t) {
          var i = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== i ? i[1] : null;
        },
        getSizedImageUrl: function e(t, i) {
          if (null == i) return t;
          if ("master" == i) return this.removeProtocol(t);
          var a = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != a) {
            var n = t.split(a[0]),
              o = a[0];
            return this.removeProtocol(n[0] + "_" + i + o);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    }),
    (theme.Disclosure = (function () {
      var e = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        t = { listVisible: "disclosure-list--visible" };
      function i(e) {
        (this.$container = e),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (i.prototype = $.extend({}, i.prototype, {
          _cacheSelectors: function t() {
            this.cache = {
              $disclosureList: this.$container.find(e.disclosureList),
              $disclosureToggle: this.$container.find(e.disclosureToggle),
              $disclosureInput: this.$container.find(e.disclosureInput),
              $disclosureOptions: this.$container.find(e.disclosureOptions),
            };
          },
          _connectToggle: function e() {
            this.cache.$disclosureToggle.on(
              "click",
              function (e) {
                var i = "true" === $(e.currentTarget).attr("aria-expanded");
                $(e.currentTarget).attr("aria-expanded", !i),
                  this.cache.$disclosureList.toggleClass(t.listVisible);
              }.bind(this)
            );
          },
          _connectOptions: function e() {
            this.cache.$disclosureOptions.on(
              "click",
              function (e) {
                e.preventDefault(),
                  this._submitForm($(e.currentTarget).data("value"));
              }.bind(this)
            );
          },
          _onFocusOut: function e() {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (e) {
                0 === this.$container.has(e.relatedTarget).length &&
                  this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (e) {
                  var i = $(e.currentTarget).has(e.relatedTarget).length > 0;
                  this.cache.$disclosureList.hasClass(t.listVisible) &&
                    !i &&
                    this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (e) {
                  27 === e.which &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (e) {
                var i = this.$container.has(e.target).length > 0;
                this.cache.$disclosureList.hasClass(t.listVisible) &&
                  !i &&
                  this._hideList();
              }.bind(this)),
              $("body").on("click", this.bodyOnClick);
          },
          _submitForm: function e(t) {
            this.cache.$disclosureInput.val(t),
              this.$container.parents("form").submit();
          },
          _hideList: function e() {
            this.cache.$disclosureList.removeClass(t.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function e() {
            $("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        i
      );
    })()),
    (function () {
      function e(e, t) {
        var i = -1,
          a = !1;
        return function () {
          clearTimeout(i),
            (i = setTimeout(e, t)),
            a ||
              (e.call(),
              (a = !0),
              setTimeout(function () {
                a = !1;
              }, t));
        };
      }
      var t = document.createEvent("Event");
      t.initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
          "scroll",
          e(function () {
            window.dispatchEvent(t);
          }, 200)
        );
    })(),
    (theme.debounce = function (e) {
      var t,
        i =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 700,
        a = arguments.length > 2 ? arguments[2] : void 0;
      return function () {
        var n = this,
          o = arguments,
          s = function i() {
            (t = null), a || e.apply(n, o);
          },
          r = a && !t;
        clearTimeout(t), (t = setTimeout(s, i)), r && e.apply(n, o);
      };
    }),
    (theme.Sections = new (function () {
      var e = this;
      (e._instances = []),
        (e._deferredSectionTargets = []),
        (e._sections = []),
        (e._deferredLoadViewportExcess = 300),
        (e._deferredWatcherRunning = !1),
        (e.init = function () {
          $(document)
            .on("shopify:section:load", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionLoad(i);
            })
            .on("shopify:section:unload", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionUnload(i);
            })
            .on("shopify:section:reorder", function (t) {
              var i = e._themeSectionTargetFromShopifySectionTarget(t.target);
              i && e.sectionReorder(i);
            }),
            $(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              e._processDeferredSections
            ),
            (e._deferredWatcherRunning = !0);
        }),
        (e.register = function (t, i, a) {
          e._sections.push({
            type: t,
            section: i,
            afterSectionLoadCallback: a ? a.afterLoad : null,
            afterSectionUnloadCallback: a ? a.afterUnload : null,
          }),
            $('[data-section-type="' + t + '"]').each(function () {
              Shopify.designMode ||
              (a && !1 === a.deferredLoad) ||
              !e._deferredWatcherRunning
                ? e.sectionLoad(this)
                : e.sectionDeferredLoad(this, a);
            });
        }),
        (e.sectionDeferredLoad = function (t, i) {
          e._deferredSectionTargets.push({
            target: t,
            deferredLoadViewportExcess:
              i && i.deferredLoadViewportExcess
                ? i.deferredLoadViewportExcess
                : e._deferredLoadViewportExcess,
          }),
            e._processDeferredSections(!0);
        }),
        (e._processDeferredSections = function (t) {
          if (e._deferredSectionTargets.length)
            for (
              var i = $(window).scrollTop(),
                a = i + $(window).height(),
                n = !0 === t ? e._deferredSectionTargets.length - 1 : 0,
                o = n;
              o < e._deferredSectionTargets.length;
              o++
            ) {
              var s = e._deferredSectionTargets[o].target,
                r = e._deferredSectionTargets[o].deferredLoadViewportExcess,
                l = $(s).offset().top - r,
                c = l > i && l < a;
              if (!c) {
                var d = l + $(s).outerHeight() + 2 * r;
                c = d > i && d < a;
              }
              (c || (l < i && d > a)) &&
                (e.sectionLoad(s), e._deferredSectionTargets.splice(o, 1), o--);
            }
          !0 !== t &&
            0 === e._deferredSectionTargets.length &&
            ((e._deferredWatcherRunning = !1),
            $(window).off(".themeSectionDeferredLoader"));
        }),
        (e.sectionLoad = function (t) {
          var t = t,
            i = e._sectionForTarget(t),
            a = !1;
          if (!1 !== (a = i.section ? i.section : i)) {
            var n = {
              target: t,
              section: a,
              $shopifySectionContainer: $(t).closest(".shopify-section"),
              thisContext: {
                functions: a.functions,
                registeredEventListeners: [],
              },
            };
            (n.thisContext.registerEventListener =
              e._registerEventListener.bind(n.thisContext)),
              e._instances.push(n),
              $(t).data("components") &&
                $(t)
                  .data("components")
                  .split(",")
                  .forEach((e) => {
                    $(document).trigger("cc:component:load", [e, t]);
                  }),
              e._callSectionWith(a, "onSectionLoad", t, n.thisContext),
              e._callSectionWith(
                a,
                "afterSectionLoadCallback",
                t,
                n.thisContext
              ),
              a.onSectionSelect &&
                n.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (t) {
                    e._callSectionWith(
                      a,
                      "onSectionSelect",
                      t.target,
                      n.thisContext
                    );
                  }
                ),
              a.onSectionDeselect &&
                n.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (t) {
                    e._callSectionWith(
                      a,
                      "onSectionDeselect",
                      t.target,
                      n.thisContext
                    );
                  }
                ),
              a.onBlockSelect &&
                $(t).on("shopify:block:select", function (t) {
                  e._callSectionWith(
                    a,
                    "onBlockSelect",
                    t.target,
                    n.thisContext
                  );
                }),
              a.onBlockDeselect &&
                $(t).on("shopify:block:deselect", function (t) {
                  e._callSectionWith(
                    a,
                    "onBlockDeselect",
                    t.target,
                    n.thisContext
                  );
                });
          }
        }),
        (e.sectionUnload = function (t) {
          for (
            var i = e._sectionForTarget(t), a = -1, n = 0;
            n < e._instances.length;
            n++
          )
            e._instances[n].target == t && (a = n);
          if (a > -1) {
            var o = e._instances[a];
            $(t).off("shopify:block:select shopify:block:deselect"),
              o.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
              ),
              e._callSectionWith(
                o.section,
                "onSectionUnload",
                t,
                o.thisContext
              ),
              e._unloadRegisteredEventListeners(
                o.thisContext.registeredEventListeners
              ),
              e._callSectionWith(
                i,
                "afterSectionUnloadCallback",
                t,
                o.thisContext
              ),
              e._instances.splice(a),
              $(t).data("components") &&
                $(t)
                  .data("components")
                  .split(",")
                  .forEach((e) => {
                    $(document).trigger("cc:component:unload", [e, t]);
                  });
          } else
            for (var n = 0; n < e._deferredSectionTargets.length; n++)
              if (e._deferredSectionTargets[n].target == t) {
                e._deferredSectionTargets[n].splice(n, 1);
                break;
              }
        }),
        (e.sectionReorder = function (t) {
          for (var i = -1, a = 0; a < e._instances.length; a++)
            e._instances[a].target == t && (i = a);
          if (i > -1) {
            var n = e._instances[i];
            e._callSectionWith(n.section, "onSectionReorder", t, n.thisContext);
          }
        }),
        (e._registerEventListener = function (e, t, i) {
          e.addEventListener(t, i),
            this.registeredEventListeners.push({
              element: e,
              eventType: t,
              callback: i,
            });
        }),
        (e._unloadRegisteredEventListeners = function (e) {
          e.forEach((e) => {
            e.element.removeEventListener(e.eventType, e.callback);
          });
        }),
        (e._callSectionWith = function (e, t, i, a) {
          if ("function" == typeof e[t])
            try {
              a ? e[t].bind(a)(i) : e[t](i);
            } catch (n) {
              var o = i.dataset.sectionType;
              console.warn(
                "Theme warning: '"
                  .concat(t, "' failed for section '")
                  .concat(o, "'")
              ),
                console.debug(i, n);
            }
        }),
        (e._themeSectionTargetFromShopifySectionTarget = function (e) {
          var t = $("[data-section-type]:first", e);
          return t.length > 0 && t[0];
        }),
        (e._sectionForTarget = function (t) {
          for (
            var i = $(t).attr("data-section-type"), a = 0;
            a < e._sections.length;
            a++
          )
            if (e._sections[a].type == i) return e._sections[a];
          return !1;
        }),
        (e._sectionAlreadyRegistered = function (t) {
          for (var i = 0; i < e._sections.length; i++)
            if (e._sections[i].type == t) return !0;
          return !1;
        });
    })()),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (e, t, i, a) {
      if (void 0 === theme.scriptsLoaded[e]) {
        theme.scriptsLoaded[e] = [];
        var n = document.createElement("script");
        (n.src = e),
          (a || i) && (n.async = !1),
          i && i(),
          "function" == typeof t &&
            (theme.scriptsLoaded[e].push(t),
            n.readyState
              ? (n.onreadystatechange = function () {
                  if ("loaded" == n.readyState || "complete" == n.readyState) {
                    n.onreadystatechange = null;
                    for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                      theme.scriptsLoaded[this][e]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(e))
              : (n.onload = function () {
                  for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                    theme.scriptsLoaded[this][e]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(e)));
        var o = document.getElementsByTagName("script")[0];
        return o.parentNode.insertBefore(n, o), !0;
      }
      if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t)
        return "function" == typeof t && t(), !1;
      theme.scriptsLoaded[e].push(t);
    }),
    (theme.loadStyleOnce = function (e) {
      var t = e.replace(/^https?:/, "");
      if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
        var i = document.createElement("link");
        (i.href = t), (i.rel = "stylesheet"), (i.type = "text/css");
        var a = document.getElementsByTagName("link")[0];
        a.parentNode.insertBefore(i, a);
      }
    }),
    (theme.showQuickPopup = function (e, t) {
      var i = $('<div class="simple-popup"/>'),
        a = t.offset();
      i.html(e).css({ left: a.left, top: a.top }).hide(),
        $("body").append(i),
        i.css({
          marginTop: -i.outerHeight() - 10,
          marginLeft: -(i.outerWidth() - t.outerWidth()) / 2,
        }),
        i
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            $(this).remove();
          });
    });
  class ccComponent {
    constructor(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e),
        i = this;
      (this.instances = []),
        $(document).on("cc:component:load", function (a, n, o) {
          n === e &&
            $(o)
              .find("".concat(t, ":not(.cc-initialized)"))
              .each(function () {
                i.init(this);
              });
        }),
        $(document).on("cc:component:unload", function (a, n, o) {
          n === e &&
            $(o)
              .find(t)
              .each(function () {
                i.destroy(this);
              });
        }),
        $(t).each(function () {
          i.init(this);
        });
    }
    init(e) {
      $(e).addClass("cc-initialized");
    }
    destroy(e) {
      $(e).removeClass("cc-initialized");
    }
    registerInstance(e, t) {
      this.instances.push({ container: e, instance: t });
    }
    destroyInstance(e) {
      this.instances = this.instances.filter((t) => {
        if (t.container === e)
          return (
            "function" == typeof t.instance.destroy && t.instance.destroy(),
            t.container !== e
          );
      });
    }
  }
  (theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      add: function e(t, i, a) {
        switch (a) {
          case "attribute":
            (this.utilityElement.innerHTML = ""),
              this.utilityElement.setAttribute("util", i),
              (this.values[t] =
                this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1]);
            break;
          case "html":
            (this.utilityElement.innerText = i),
              (this.values[t] = this.utilityElement.innerHTML);
            break;
          case "raw":
            this.values[t] = i;
            break;
          default:
            throw "Type '".concat(a, "' not handled");
        }
      },
    };
  }),
    (theme.suffixIds = function (e, t) {
      var i = ["aria-describedby", "aria-controls"];
      (t = "-" + t),
        e.querySelectorAll("[id]").forEach((a) => {
          var n = a.id,
            o = n + t;
          (a.id = o),
            i.forEach((t) => {
              e.querySelectorAll("[".concat(t, '="').concat(n, '"]')).forEach(
                (e) => {
                  e.setAttribute(t, o);
                }
              );
            });
        });
    }),
    (theme.renderUnitPrice = function (e, t, i) {
      if (!e || !t) return "";
      var a = '<div class="unit-price">';
      (a += '<span class="unit-price__price theme-money">'.concat(
        theme.Shopify.formatMoney(e, i),
        "</span>"
      )),
        (a += '<span class="unit-price__separator">'.concat(
          theme.strings.products_product_unit_price_separator,
          "</span>"
        ));
      var n = t.reference_unit;
      return (
        1 != t.reference_value && (n = t.reference_value + n),
        (a += '<span class="unit-price__unit">'.concat(n, "</span>")),
        (a += "</div>")
      );
    });
  class ccPopup {
    constructor(e, t) {
      (this.$container = e),
        (this.namespace = t),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    open(e) {
      if (this.$container.data("freeze-scroll")) {
        clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId),
          $("body").addClass(this.cssClasses.bodyNoScroll);
        var t = document.createElement("div");
        (t.className = "popup-scrollbar-measure"), document.body.appendChild(t);
        var i = t.getBoundingClientRect().width - t.clientWidth;
        document.body.removeChild(t),
          i > 0 &&
            $("body")
              .css("padding-right", i + "px")
              .addClass(this.cssClasses.bodyNoScrollPadRight);
      }
      this.$container.addClass(this.cssClasses.visible),
        (this.previouslyActiveElement = document.activeElement),
        setTimeout(() => {
          this.$container.find(".cc-popup-close")[0].focus();
        }, 500),
        $(window).on("keydown" + this.namespace, (e) => {
          27 === e.keyCode && this.close();
        }),
        e && e();
    }
    close(e) {
      if (
        (this.$container.removeClass(this.cssClasses.visible),
        this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
        $(window).off("keydown" + this.namespace),
        0 ===
          $("." + this.cssClasses.visible).filter(() =>
            this.$container.data("freeze-scroll")
          ).length)
      ) {
        var t = 500,
          i = this.$container.find(".cc-popup-modal");
        i.length &&
          (t = parseFloat(getComputedStyle(i[0]).transitionDuration)) &&
          t > 0 &&
          (t *= 1e3),
          (theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout(() => {
            $("body")
              .removeClass(this.cssClasses.bodyNoScroll)
              .removeClass(this.cssClasses.bodyNoScrollPadRight)
              .css("padding-right", "0");
          }, t));
      }
      e && e();
    }
  }
  (() => {
    (theme.initAnimateOnScroll = function () {
      if (
        document.body.classList.contains("cc-animate-enabled") &&
        window.innerWidth >= 768
      ) {
        var e =
          void 0 !== document.body.dataset.ccAnimateTimeout
            ? document.body.dataset.ccAnimateTimeout
            : 200;
        if ("IntersectionObserver" in window) {
          var t = new IntersectionObserver((t, i) => {
            t.forEach((t) => {
              t.isIntersecting &&
                !t.target.classList.contains("cc-animate-complete") &&
                (setTimeout(() => {
                  t.target.classList.add("-in", "cc-animate-complete");
                }, e),
                setTimeout(() => {
                  t.target.classList.remove("data-cc-animate"),
                    (t.target.style.transitionDuration = null),
                    (t.target.style.transitionDelay = null);
                }, 5e3),
                i.unobserve(t.target));
            });
          });
          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach((e) => {
              e.dataset.ccAnimateDelay &&
                (e.style.transitionDelay = e.dataset.ccAnimateDelay),
                e.dataset.ccAnimateDuration &&
                  (e.style.transitionDuration = e.dataset.ccAnimateDuration),
                e.dataset.ccAnimate && e.classList.add(e.dataset.ccAnimate),
                e.classList.add("cc-animate-init"),
                t.observe(e);
            });
        } else
          for (
            var i = document.querySelectorAll(
                "[data-cc-animate]:not(.cc-animate-init)"
              ),
              a = 0;
            a < i.length;
            a++
          )
            i[a].classList.add("-in", "cc-animate-complete");
      }
    }),
      theme.initAnimateOnScroll(),
      document.addEventListener("shopify:section:load", () => {
        setTimeout(theme.initAnimateOnScroll, 100);
      });
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", (e) => {
          e.matches && setTimeout(theme.initAnimateOnScroll, 100);
        });
    } catch (e) {}
  })();
  class AccordionInstance {
    constructor(e) {
      (this.accordion = e),
        (this.itemClass = ".cc-accordion-item"),
        (this.titleClass = ".cc-accordion-item__title"),
        (this.panelClass = ".cc-accordion-item__panel"),
        (this.allowMultiOpen =
          "true" === this.accordion.dataset.allowMultiOpen),
        this.allowMultiOpen ||
          (this.activeItem = this.accordion.querySelector(
            "".concat(this.itemClass, "[open]")
          )),
        this.bindEvents();
    }
    static addPanelHeight(e) {
      e.style.height = "".concat(e.scrollHeight, "px");
    }
    static removePanelHeight(e) {
      e.getAttribute("style"), e.removeAttribute("style");
    }
    open(e, t) {
      if (
        ((t.style.height = "0"),
        (e.open = !0),
        AccordionInstance.addPanelHeight(t),
        setTimeout(() => {
          e.classList.add("is-open");
        }, 10),
        !this.allowMultiOpen)
      ) {
        if (this.activeItem && this.activeItem !== e) {
          var i = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, i);
        }
        this.activeItem = e;
      }
    }
    close(e, t) {
      AccordionInstance.addPanelHeight(t),
        e.classList.remove("is-open"),
        e.classList.add("is-closing"),
        this.activeItem === e && (this.activeItem = null),
        setTimeout(() => {
          t.style.height = "0";
        }, 10);
    }
    handleClick(e) {
      var t = e.target.closest(this.titleClass);
      if (t) {
        e.preventDefault();
        var i = t.parentNode,
          a = t.nextElementSibling;
        i.open ? this.close(i, a) : this.open(i, a);
      }
    }
    handleTransition(e) {
      if (e.target.matches(this.panelClass)) {
        var t = e.target,
          i = t.parentNode;
        i.classList.contains("is-closing") &&
          (i.classList.remove("is-closing"), (i.open = !1)),
          AccordionInstance.removePanelHeight(t);
      }
    }
    bindEvents() {
      (this.clickHandler = this.handleClick.bind(this)),
        (this.transitionHandler = this.handleTransition.bind(this)),
        this.accordion.addEventListener("click", this.clickHandler),
        this.accordion.addEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
    destroy() {
      this.accordion.removeEventListener("click", this.clickHandler),
        this.accordion.removeEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
  }
  class Accordion extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "accordion",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new AccordionInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new Accordion();
  class CustomSelectInstance {
    constructor(e) {
      (this.el = e),
        (this.button = e.querySelector(".cc-select__btn")),
        (this.listbox = e.querySelector(".cc-select__listbox")),
        (this.options = e.querySelectorAll(".cc-select__option")),
        (this.selectedOption = e.querySelector('[aria-selected="true"]')),
        (this.nativeSelect = document.getElementById(
          "".concat(e.id, "-native")
        )),
        (this.swatches =
          "swatch" in this.options[this.options.length - 1].dataset),
        (this.focusedClass = "is-focused"),
        (this.searchString = ""),
        (this.listboxOpen = !1),
        this.selectedOption ||
          (this.selectedOption = this.listbox.firstElementChild),
        this.bindEvents(),
        this.setButtonWidth();
    }
    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.el.addEventListener(
          "selectOption",
          this.handleSelectOption.bind(this)
        ),
        this.button.addEventListener(
          "mousedown",
          this.handleMousedown.bind(this)
        );
    }
    addListboxOpenEvents() {
      (this.mouseoverHandler = this.handleMouseover.bind(this)),
        (this.mouseleaveHandler = this.handleMouseleave.bind(this)),
        (this.clickHandler = this.handleClick.bind(this)),
        (this.blurHandler = this.handleBlur.bind(this)),
        this.listbox.addEventListener("mouseover", this.mouseoverHandler),
        this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.addEventListener("click", this.clickHandler),
        this.listbox.addEventListener("blur", this.blurHandler);
    }
    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler),
        this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.removeEventListener("click", this.clickHandler),
        this.listbox.removeEventListener("blur", this.blurHandler);
    }
    handleKeydown(e) {
      this.listboxOpen
        ? this.handleKeyboardNav(e)
        : ("ArrowUp" === e.key || "ArrowDown" === e.key || " " === e.key) &&
          (e.preventDefault(), this.showListbox());
    }
    handleMousedown(e) {
      this.listboxOpen || 0 !== e.button || this.showListbox();
    }
    handleMouseover(e) {
      e.target.matches("li") && this.focusOption(e.target);
    }
    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }
    handleClick(e) {
      e.target.matches(".js-option") && this.selectOption(e.target);
    }
    handleBlur() {
      this.listboxOpen && this.hideListbox();
    }
    handleKeyboardNav(e) {
      var t;
      switch (("Tab" === e.key && e.preventDefault(), e.key)) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(),
            (t =
              "ArrowUp" === e.key
                ? this.focusedOption.previousElementSibling
                : this.focusedOption.nextElementSibling) &&
              !t.classList.contains("is-disabled") &&
              this.focusOption(t);
          break;
        case "Enter":
        case " ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case "Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (t = this.findOption(e.key)) && this.focusOption(t);
      }
    }
    setButtonWidth() {
      var e = (e) => {
          var t = getComputedStyle(e);
          return parseFloat(t.paddingLeft) + parseFloat(t.paddingRight);
        },
        t = e(this.button),
        i = e(this.selectedOption),
        a = this.button.offsetWidth - this.button.clientWidth,
        n = Math.ceil(this.selectedOption.getBoundingClientRect().width);
      this.button.style.width = "".concat(n - i + t + a, "px");
    }
    showListbox() {
      (this.listbox.hidden = !1),
        (this.listboxOpen = !0),
        this.el.classList.add("is-open"),
        this.button.setAttribute("aria-expanded", "true"),
        this.listbox.setAttribute("aria-hidden", "false"),
        setTimeout(() => {
          this.focusOption(this.selectedOption),
            this.listbox.focus(),
            this.addListboxOpenEvents();
        }, 10);
    }
    hideListbox() {
      this.listboxOpen &&
        ((this.listbox.hidden = !0),
        (this.listboxOpen = !1),
        this.el.classList.remove("is-open"),
        this.button.setAttribute("aria-expanded", "false"),
        this.listbox.setAttribute("aria-hidden", "true"),
        this.focusedOption &&
          (this.focusedOption.classList.remove(this.focusedClass),
          (this.focusedOption = null)),
        this.button.focus(),
        this.removeListboxOpenEvents());
    }
    findOption(e) {
      return (
        (this.searchString += e),
        this.searchTimer && clearTimeout(this.searchTimer),
        (this.searchTimer = setTimeout(() => {
          this.searchString = "";
        }, 500)),
        [...this.options].find(
          (e) =>
            e.innerText.toLowerCase().includes(this.searchString) &&
            !e.classList.contains("is-disabled")
        )
      );
    }
    focusOption(e) {
      if (
        (this.focusedOption &&
          this.focusedOption.classList.remove(this.focusedClass),
        (this.focusedOption = e),
        this.focusedOption.classList.add(this.focusedClass),
        this.listbox.scrollHeight > this.listbox.clientHeight)
      ) {
        var t = this.listbox.clientHeight + this.listbox.scrollTop,
          i = e.offsetTop + e.offsetHeight;
        i > t
          ? (this.listbox.scrollTop = i - this.listbox.clientHeight)
          : e.offsetTop < this.listbox.scrollTop &&
            (this.listbox.scrollTop = e.offsetTop);
      }
    }
    handleSelectOption(e) {
      var t = [...this.options].find((t) => t.dataset.value === e.detail.value);
      t && this.selectOption(t);
    }
    selectOption(e) {
      if (e !== this.selectedOption) {
        if (
          (e.setAttribute("aria-selected", "true"),
          this.selectedOption.setAttribute("aria-selected", "false"),
          this.swatches &&
            (e.dataset.swatch
              ? (this.button.dataset.swatch = e.dataset.swatch)
              : this.button.removeAttribute("data-swatch")),
          (this.button.firstChild.textContent =
            e.firstElementChild.textContent),
          this.listbox.setAttribute("aria-activedescendant", e.id),
          (this.selectedOption = document.getElementById(e.id)),
          this.nativeSelect)
        )
          (this.nativeSelect.value = e.dataset.value),
            this.nativeSelect.dispatchEvent(
              new Event("change", { bubbles: !0 })
            );
        else {
          var t = { selectedValue: e.dataset.value };
          this.el.dispatchEvent(
            new CustomEvent("change", { bubbles: !0, detail: t })
          );
        }
      }
      this.hideListbox();
    }
  }
  class CustomSelect extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "custom-select",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-select";
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new CustomSelectInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new CustomSelect();
  class ModalInstance {
    constructor(e) {
      (this.container = e),
        (this.size = e.dataset.ccModalSize || "medium"),
        (this.contentElement = document.querySelector(
          e.dataset.ccModalContentelement
        )),
        this.container.addEventListener("click", this.handleClick.bind(this)),
        "true" === e.dataset.ccModalLaunch &&
          setTimeout(this.open.bind(this), 10);
    }
    handleClick(e) {
      e.preventDefault(), this.open(), (this.opener = e.target);
    }
    open() {
      var e = theme.createTemplateVariableEncoder();
      e.add("size", this.size, "attribute"),
        e.add("content", this.contentElement.innerHTML, "raw"),
        e.add(
          "button_close_label",
          theme.strings.general_accessibility_labels_close,
          "attribute"
        ),
        e.add("button_close_icon", theme.icons.close, "raw");
      var t =
          '\n      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-'
            .concat(
              e.values.size,
              '">\n        <div class="cc-modal-window__background"></div>\n        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">\n          <div class="cc-modal-window__content-container">\n            <button class="cc-modal-window__close" aria-label="'
            )
            .concat(e.values.button_close_label, '">')
            .concat(
              e.values.button_close_icon,
              '</button>\n            <div class="cc-modal-window__content">'
            )
            .concat(
              e.values.content,
              "</div>\n          </div>\n        </div>\n      </div>\n    "
            ),
        i = document.createRange().createContextualFragment(t);
      document.body.appendChild(i),
        document.body.classList.add("cc-modal-visible"),
        (this.modalElement = document.body.lastElementChild),
        this.modalElement
          .querySelector(".cc-modal-window__background")
          .addEventListener("click", this.close.bind(this)),
        this.modalElement
          .querySelector(".cc-modal-window__close")
          .addEventListener("click", this.close.bind(this)),
        setTimeout(() => {
          this.modalElement.classList.remove("cc-modal-window--pre-reveal"),
            this.modalElement.querySelector(".cc-modal-window__close").focus();
        }, 10);
    }
    close() {
      this.modalElement.classList.add("cc-modal-window--closing"),
        document.querySelector(
          ".cc-modal-window:not(.cc-modal-window--closing)"
        ) || document.body.classList.remove("cc-modal-visible"),
        this.opener &&
          setTimeout(() => {
            this.opener.focus();
          }, 10),
        setTimeout(
          function () {
            this.remove();
          }.bind(this.modalElement),
          5e3
        );
    }
  }
  class Modal extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "modal",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new ModalInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new Modal();
  class PriceRangeInstance {
    constructor(e) {
      (this.container = e),
        (this.selectors = {
          inputMin: ".cc-price-range__input--min",
          inputMax: ".cc-price-range__input--max",
          control: ".cc-price-range__control",
          controlMin: ".cc-price-range__control--min",
          controlMax: ".cc-price-range__control--max",
          bar: ".cc-price-range__bar",
          activeBar: ".cc-price-range__bar-active",
        }),
        (this.controls = {
          min: {
            barControl: e.querySelector(this.selectors.controlMin),
            input: e.querySelector(this.selectors.inputMin),
          },
          max: {
            barControl: e.querySelector(this.selectors.controlMax),
            input: e.querySelector(this.selectors.inputMax),
          },
        }),
        (this.controls.min.value = parseInt(
          "" === this.controls.min.input.value
            ? this.controls.min.input.placeholder
            : this.controls.min.input.value
        )),
        (this.controls.max.value = parseInt(
          "" === this.controls.max.input.value
            ? this.controls.max.input.placeholder
            : this.controls.max.input.value
        )),
        (this.valueMin = this.controls.min.input.min),
        (this.valueMax = this.controls.min.input.max),
        (this.valueRange = this.valueMax - this.valueMin),
        [this.controls.min, this.controls.max].forEach((e) => {
          e.barControl.setAttribute("aria-valuemin", this.valueMin),
            e.barControl.setAttribute("aria-valuemax", this.valueMax),
            e.barControl.setAttribute("tabindex", 0);
        }),
        this.controls.min.barControl.setAttribute(
          "aria-valuenow",
          this.controls.min.value
        ),
        this.controls.max.barControl.setAttribute(
          "aria-valuenow",
          this.controls.max.value
        ),
        (this.bar = e.querySelector(this.selectors.bar)),
        (this.activeBar = e.querySelector(this.selectors.activeBar)),
        (this.inDrag = !1),
        (this.rtl = document.querySelector("html[dir=rtl]")),
        this.bindEvents(),
        this.render();
    }
    getPxToValueRatio() {
      var e = this.bar.clientWidth / (this.valueMax - this.valueMin);
      return this.rtl ? -e : e;
    }
    getPcToValueRatio() {
      return 100 / (this.valueMax - this.valueMin);
    }
    setActiveControlValue(e) {
      isNaN(parseInt(e)) ||
        (this.activeControl === this.controls.min
          ? ("" === e && (e = this.valueMin),
            (e = Math.min(
              (e = Math.max(this.valueMin, e)),
              this.controls.max.value
            )))
          : ("" === e && (e = this.valueMax),
            (e = Math.max(
              (e = Math.min(this.valueMax, e)),
              this.controls.min.value
            ))),
        (this.activeControl.value = Math.round(e)),
        this.activeControl.input.value != this.activeControl.value &&
          (this.activeControl.value == this.activeControl.input.placeholder
            ? (this.activeControl.input.value = "")
            : (this.activeControl.input.value = this.activeControl.value),
          this.activeControl.input.dispatchEvent(
            new CustomEvent("change", {
              bubbles: !0,
              cancelable: !1,
              detail: { sender: "theme:component:price_range" },
            })
          )),
        this.activeControl.barControl.setAttribute(
          "aria-valuenow",
          this.activeControl.value
        ));
    }
    render() {
      this.drawControl(this.controls.min),
        this.drawControl(this.controls.max),
        this.drawActiveBar();
    }
    drawControl(e) {
      var t = (e.value - this.valueMin) * this.getPcToValueRatio() + "%";
      this.rtl ? (e.barControl.style.right = t) : (e.barControl.style.left = t);
    }
    drawActiveBar() {
      var e =
          (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() +
          "%",
        t =
          (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() +
          "%";
      this.rtl
        ? ((this.activeBar.style.left = t), (this.activeBar.style.right = e))
        : ((this.activeBar.style.left = e), (this.activeBar.style.right = t));
    }
    handleControlTouchStart(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.touches[0].clientX),
        (this.boundControlTouchMoveEvent =
          this.handleControlTouchMove.bind(this)),
        (this.boundControlTouchEndEvent =
          this.handleControlTouchEnd.bind(this)),
        window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
        window.addEventListener("touchend", this.boundControlTouchEndEvent);
    }
    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }
    handleControlTouchEnd(e) {
      e.preventDefault(),
        window.removeEventListener(
          "touchmove",
          this.boundControlTouchMoveEvent
        ),
        window.removeEventListener("touchend", this.boundControlTouchEndEvent),
        this.stopDrag();
    }
    handleControlMouseDown(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.clientX),
        (this.boundControlMouseMoveEvent =
          this.handleControlMouseMove.bind(this)),
        (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
        window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
        window.addEventListener("mouseup", this.boundControlMouseUpEvent);
    }
    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }
    handleControlMouseUp(e) {
      e.preventDefault(),
        window.removeEventListener(
          "mousemove",
          this.boundControlMouseMoveEvent
        ),
        window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
        this.stopDrag();
    }
    startDrag(e, t) {
      this.controls.min.barControl === e
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        (this.dragStartX = t),
        (this.dragStartValue = this.activeControl.value),
        (this.inDrag = !0);
    }
    moveDrag(e) {
      if (this.inDrag) {
        var t =
          this.dragStartValue +
          (e - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(t), this.render();
      }
    }
    stopDrag() {
      this.inDrag = !1;
    }
    handleControlKeyDown(e) {
      "ArrowRight" === e.key
        ? this.incrementControlFromKeypress(e.target, 10)
        : "ArrowLeft" === e.key &&
          this.incrementControlFromKeypress(e.target, -10);
    }
    incrementControlFromKeypress(e, t) {
      this.controls.min.barControl === e
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        this.setActiveControlValue(
          this.activeControl.value + t / this.getPxToValueRatio()
        ),
        this.render();
    }
    handleInputChange(e) {
      (e.target.value = e.target.value.replace(/\D/g, "")),
        (e.detail && "theme:component:price_range" == e.detail.sender) ||
          (this.controls.min.input === e.target
            ? (this.activeControl = this.controls.min)
            : (this.activeControl = this.controls.max),
          this.setActiveControlValue(e.target.value),
          this.render());
    }
    handleInputKeyup(e) {
      setTimeout(
        function () {
          this.value = this.value.replace(/\D/g, "");
        }.bind(e.target),
        10
      );
    }
    bindEvents() {
      [this.controls.min, this.controls.max].forEach((e) => {
        e.barControl.addEventListener(
          "touchstart",
          this.handleControlTouchStart.bind(this)
        ),
          e.barControl.addEventListener(
            "mousedown",
            this.handleControlMouseDown.bind(this)
          ),
          e.barControl.addEventListener(
            "keydown",
            this.handleControlKeyDown.bind(this)
          ),
          e.input.addEventListener("change", this.handleInputChange.bind(this)),
          e.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
      });
    }
    destroy() {}
  }
  class PriceRange extends ccComponent {
    constructor() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : "price-range",
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : ".cc-".concat(e);
      super(e, t);
    }
    init(e) {
      super.init(e), this.registerInstance(e, new PriceRangeInstance(e));
    }
    destroy(e) {
      this.destroyInstance(e), super.destroy(e);
    }
  }
  new PriceRange(),
    (theme.VideoManager = new (function () {
      var e = this;
      (e.videos = { incrementor: 0, videoData: {} }),
        (e._loadYoutubeVideos = function (t) {
          $(
            '.video-container[data-video-type="youtube"]:not(.video--init)',
            t
          ).each(function () {
            $(this).addClass("video--init"), e.videos.incrementor++;
            var t = "theme-yt-video-" + e.videos.incrementor;
            $(this).data("video-container-id", t);
            var i = $(this).data("video-autoplay"),
              a = $(this).data("video-loop"),
              n = $(this).data("video-id"),
              o = $(this).hasClass("video-container--background"),
              s = new URLSearchParams(
                "iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&playslinline=1"
              );
            s.append("origin", location.origin),
              s.append("playlist", n),
              s.append("loop", a ? 1 : 0),
              s.append("autoplay", 0),
              s.append("controls", o ? 0 : 1);
            var r = e.videos.incrementor;
            s.append("widgetid", r);
            var l = "https://www.youtube.com/embed/" + n + "?" + s.toString(),
              c = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">'
              )
                .attr({
                  id: t,
                  width: 640,
                  height: 360,
                  tabindex: o ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (e.videos.videoData[t] = {
              type: "yt",
              id: t,
              container: this,
              mute: () =>
                c[0].contentWindow.postMessage(
                  '{"event":"command","func":"mute","args":""}',
                  "*"
                ),
              play: () =>
                c[0].contentWindow.postMessage(
                  '{"event":"command","func":"playVideo","args":""}',
                  "*"
                ),
              pause: () =>
                c[0].contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*"
                ),
              stop: () =>
                c[0].contentWindow.postMessage(
                  '{"event":"command","func":"stopVideo","args":""}',
                  "*"
                ),
              seekTo: (e) =>
                c[0].contentWindow.postMessage(
                  '{"event":"command","func":"seekTo","args":['.concat(
                    e,
                    ",true]}"
                  ),
                  "*"
                ),
              videoElement: c[0],
              isBackgroundVideo: o,
              establishedYTComms: !1,
            }),
              i &&
                c.on("load", () =>
                  setTimeout(() => {
                    window.addEventListener("message", (i) => {
                      if (
                        "https://www.youtube.com" === i.origin &&
                        i.data &&
                        "string" == typeof i.data
                      ) {
                        var n = JSON.parse(i.data);
                        "initialDelivery" === n.event &&
                          n.info &&
                          n.info.duration &&
                          (e.videos.videoData[t].duration = n.info.duration),
                          "infoDelivery" === n.event &&
                            "widget" === n.channel &&
                            n.id === r &&
                            ((e.videos.videoData[t].establishedYTComms = !0),
                            n.info &&
                              1 === n.info.playerState &&
                              $(this).addClass("video-container--playing"),
                            a &&
                              n.info &&
                              n.info.currentTime >
                                e.videos.videoData[t].duration - 1 &&
                              e.videos.videoData[t].seekTo(0));
                      }
                    }),
                      c[0].contentWindow.postMessage(
                        '{"event":"listening","id":'.concat(
                          r,
                          ',"channel":"widget"}'
                        ),
                        "*"
                      ),
                      e.videos.videoData[t].mute(),
                      e.videos.videoData[t].play(),
                      setTimeout(() => {
                        e.videos.videoData[t].establishedYTComms ||
                          $(this).addClass("video-container--playing");
                      }, 2e3);
                  }, 100)
                ),
              o &&
                (c.attr("tabindex", "-1"),
                e._initBackgroundVideo(e.videos.videoData[t]),
                e.addYTPageshowListenerHack()),
              c.attr("src", l),
              fetch(
                "https://www.youtube.com/oembed?format=json&url=" +
                  encodeURIComponent($(this).data("video-url"))
              )
                .then((e) => {
                  if (!e.ok)
                    throw Error("HTTP error! Status: ".concat(e.status));
                  return e.json();
                })
                .then((i) => {
                  i.width &&
                    i.height &&
                    (c.attr({ width: i.width, height: i.height }),
                    e.videos.videoData[t].assessBackgroundVideo &&
                      e.videos.videoData[t].assessBackgroundVideo());
                });
          });
        }),
        (e._loadVimeoVideos = function (t) {
          $(
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
            t
          ).each(function () {
            $(this).addClass("video--init"), e.videos.incrementor++;
            var t = "theme-vi-video-" + e.videos.incrementor;
            $(this).data("video-container-id", t);
            var i = $(this).data("video-autoplay"),
              a = $(this).data("video-loop"),
              n = $(this).data("video-id"),
              o = $(this).hasClass("video-container--background"),
              s = new URLSearchParams();
            i && s.append("muted", 1),
              a && s.append("loop", 1),
              o && s.append("controls", 0);
            var r = "https://player.vimeo.com/video/" + n + "?" + s.toString(),
              l = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">'
              )
                .attr({
                  id: t,
                  width: 640,
                  height: 360,
                  tabindex: o ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (e.videos.videoData[t] = {
              type: "vimeo",
              id: t,
              container: this,
              play: () =>
                l[0].contentWindow.postMessage('{"method":"play"}', "*"),
              pause: () =>
                l[0].contentWindow.postMessage('{"method":"pause"}', "*"),
              videoElement: l[0],
              isBackgroundVideo: o,
              establishedVimeoComms: !1,
            }),
              i &&
                l.on("load", () =>
                  setTimeout(() => {
                    window.addEventListener("message", (i) => {
                      if (
                        "https://player.vimeo.com" === i.origin &&
                        i.source === l[0].contentWindow &&
                        i.data
                      ) {
                        var a = i.data;
                        "string" == typeof a && (a = JSON.parse(a)),
                          ("ping" === a.method || "playing" === a.event) &&
                            (e.videos.videoData[t].establishedVimeoComms = !0),
                          "playing" === a.event &&
                            $(this).addClass("video-container--playing");
                      }
                    }),
                      l[0].contentWindow.postMessage(
                        { method: "addEventListener", value: "playing" },
                        "*"
                      ),
                      l[0].contentWindow.postMessage(
                        {
                          method: "appendVideoMetadata",
                          value: location.origin,
                        },
                        "*"
                      ),
                      l[0].contentWindow.postMessage({ method: "ping" }, "*"),
                      e.videos.videoData[t].play(),
                      setTimeout(() => {
                        e.videos.videoData[t].establishedVimeoComms ||
                          $(this).addClass("video-container--playing");
                      }, 2e3);
                  }, 100)
                ),
              o &&
                (l.attr("tabindex", "-1"),
                e._initBackgroundVideo(e.videos.videoData[t])),
              l.attr("src", r),
              fetch(
                "https://vimeo.com/api/oembed.json?url=" +
                  encodeURIComponent($(this).data("video-url"))
              )
                .then((e) => {
                  if (!e.ok)
                    throw Error("HTTP error! Status: ".concat(e.status));
                  return e.json();
                })
                .then((i) => {
                  i.width &&
                    i.height &&
                    (l.attr({ width: i.width, height: i.height }),
                    e.videos.videoData[t].assessBackgroundVideo &&
                      e.videos.videoData[t].assessBackgroundVideo());
                });
          });
        }),
        (e._loadMp4Videos = function (t) {
          $('.video-container[data-video-type="mp4"]:not(.video--init)', t)
            .addClass("video--init")
            .each(function () {
              e.videos.incrementor++;
              var i = "theme-mp-video-" + e.videos.incrementor,
                a = $(this);
              $(this).data("video-container-id", i);
              var n = $('<div class="video-container__video-element">')
                  .attr("id", i)
                  .appendTo($(".video-container__video", this)),
                o = $(this).data("video-autoplay"),
                s = $(this).hasClass("video-container--background"),
                r = $("<video playsinline>");
              if (
                ($(this).data("video-loop") && r.attr("loop", "loop"),
                r.on("click mouseenter", () => r.attr("controls", "controls")),
                o &&
                  (r.attr({ autoplay: "autoplay", muted: "muted" }),
                  (r[0].muted = !0),
                  r.one("loadeddata", function () {
                    this.play(), a.addClass("video-container--playing");
                  })),
                $(this).data("video-url") &&
                  r.attr("src", $(this).data("video-url")),
                $(this).data("video-sources"))
              )
                for (
                  var l = $(this).data("video-sources").split("|"), c = 0;
                  c < l.length;
                  c++
                ) {
                  var [d, h, u] = l[c].split(" ");
                  !("m3u8" === d && $(this).data("video-loop")) &&
                    $("<source>").attr({ src: u, type: h }).appendTo(r);
                }
              r.appendTo(n);
              var p = (e.videos.videoData[i] = {
                type: "mp4",
                element: r[0],
                play: () => r[0].play(),
                pause: () => r[0].pause(),
                isBackgroundVideo: s,
              });
              s &&
                (r.attr("tabindex", "-1"),
                o && t.addEventListener("click", p.play, { once: !0 }));
            });
        }),
        (e._initBackgroundVideo = function (e) {
          e.container.classList.contains("video-container--background") &&
            ((e.assessBackgroundVideo = function () {
              var e = this.offsetWidth,
                t = this.offsetHeight,
                i = e / t,
                a = this.querySelector("iframe"),
                n = parseFloat(a.width) / parseFloat(a.height),
                o = this.querySelector(".video-container__video"),
                s = 75;
              if (i > n) {
                var r = e / n + 2 * s;
                (o.style.marginTop = (t - r) / 2 - s + "px"),
                  (o.style.marginInlineStart = ""),
                  (o.style.height = r + 2 * s + "px"),
                  (o.style.width = "");
              } else {
                var l = t + 2 * s,
                  c = l * n;
                (o.style.marginTop = -s + "px"),
                  (o.style.marginInlineStart = (e - c) / 2 + "px"),
                  (o.style.height = l + "px"),
                  (o.style.width = c + "px");
              }
            }.bind(e.container)),
            e.assessBackgroundVideo(),
            $(window).on("debouncedresize." + e.id, e.assessBackgroundVideo),
            e.container.addEventListener("click", e.play, { once: !0 }));
        }),
        (e._unloadVideos = function (t) {
          for (var i in e.videos.videoData) {
            var a = e.videos.videoData[i];
            if ($(t).find(a.container).length) {
              delete e.videos.videoData[i];
              return;
            }
          }
        }),
        (this.onSectionLoad = function (t) {
          $(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var e = $(this).data("video-url");
              e.indexOf(".mp4") > -1 && $(this).attr("data-video-type", "mp4"),
                e.indexOf("vimeo.com") > -1 &&
                  ($(this).attr("data-video-type", "vimeo"),
                  $(this).attr(
                    "data-video-id",
                    e.split("?")[0].split("/").pop()
                  )),
                (e.indexOf("youtu.be") > -1 || e.indexOf("youtube.com") > -1) &&
                  ($(this).attr("data-video-type", "youtube"),
                  e.indexOf("v=") > -1
                    ? $(this).attr(
                        "data-video-id",
                        e.split("v=").pop().split("&")[0]
                      )
                    : $(this).attr(
                        "data-video-id",
                        e.split("?")[0].split("/").pop()
                      ));
            }
          ),
            e._loadYoutubeVideos(t),
            e._loadVimeoVideos(t),
            e._loadMp4Videos(t),
            $(".video-container__play", t).on("click", function (t) {
              t.preventDefault();
              var i = $(this).closest(".video-container");
              i.addClass("video-container--playing"),
                i.trigger("cc:video:play");
              var a = i.data("video-container-id");
              e.videos.videoData[a].play();
            }),
            $(".video-container__stop", t).on("click", function (t) {
              t.preventDefault();
              var i = $(this).closest(".video-container");
              i.removeClass("video-container--playing"),
                i.trigger("cc:video:stop");
              var a = i.data("video-container-id");
              e.videos.videoData[a].pause();
            });
        }),
        (this.onSectionUnload = function (t) {
          $(".video-container__play, .video-container__stop", t).off("click"),
            $(window).off(
              "." + $(".video-container").data("video-container-id")
            ),
            $(window).off("debouncedresize.video-manager-resize"),
            e._unloadVideos(t),
            $(t).trigger("cc:video:stop");
        }),
        (e.addYTPageshowListenerHack = function () {
          e.pageshowListenerAdded ||
            ((e.pageshowListenerAdded = !0),
            window.addEventListener("pageshow", (t) => {
              t.persisted &&
                Object.keys(e.videos.videoData)
                  .filter(
                    (t) =>
                      "yt" === e.videos.videoData[t].type &&
                      e.videos.videoData[t].isBackgroundVideo
                  )
                  .forEach((t) => {
                    e.videos.videoData[t].stop(), e.videos.videoData[t].play();
                  });
            }));
        });
    })()),
    cc.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.MapSection = new (function () {
      var e = this;
      (e.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      }),
        (e.apiStatus = null),
        (this.geolocate = function (e) {
          var t = $.Deferred(),
            i = new google.maps.Geocoder(),
            a = e.data("address-setting");
          return (
            i.geocode({ address: a }, function (e, i) {
              i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
            }),
            t
          );
        }),
        (this.createMap = function (t) {
          var i = $(".map-section__map-container", t);
          return e
            .geolocate(i)
            .then(
              function (a) {
                var n = {
                  zoom: e.config.zoom,
                  styles: e.config.styles[$(t).data("map-style")],
                  center: a[0].geometry.location,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                  zoomControl: !i.data("hide-zoom"),
                };
                (e.map = new google.maps.Map(i[0], n)),
                  (e.center = e.map.getCenter()),
                  new google.maps.Marker({
                    map: e.map,
                    position: e.center,
                    clickable: !1,
                  }),
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    function () {
                      google.maps.event.trigger(e.map, "resize"),
                        e.map.setCenter(e.center);
                    }
                  );
              }.bind(this)
            )
            .fail(function () {
              var e;
              switch (status) {
                case "ZERO_RESULTS":
                  e = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  e = theme.strings.addressQueryLimit;
                  break;
                default:
                  e = theme.strings.addressError;
              }
              if (Shopify.designMode) {
                var t = i.parents(".map-section");
                t.addClass("page-width map-section--load-error"),
                  t
                    .find(".map-section__wrapper")
                    .html('<div class="errors text-center">' + e + "</div>");
              }
            });
        }),
        (this.onSectionLoad = function (t) {
          var i = $(t);
          window.gm_authFailure = function () {
            Shopify.designMode &&
              (i.addClass("page-width map-section--load-error"),
              i
                .find(".map-section__wrapper")
                .html(
                  '<div class="errors text-center">' +
                    theme.strings.authError +
                    "</div>"
                ));
          };
          var a = i.data("api-key");
          "string" == typeof a &&
            "" !== a &&
            theme.loadScriptOnce(
              "https://maps.googleapis.com/maps/api/js?key=" + a,
              function () {
                e.createMap(i);
              }
            );
        }),
        (this.onSectionUnload = function (t) {
          void 0 !== window.google &&
            void 0 !== google.maps &&
            google.maps.event.clearListeners(e.map, "resize");
        });
    })()),
    cc.sections.push({ name: "map", section: theme.MapSection }),
    (theme.FaqHeader = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.container = e),
          (this.classNames = {
            questionContainerInactive: "faq-search-item-inactive",
            sectionWithIndexStatus: "section-faq-header--with-index",
          }),
          (this.searchInput =
            this.container.querySelector(".faq-search__input")),
          this.searchInput &&
            (this.registerEventListener(
              this.searchInput,
              "change",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "keyup",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "paste",
              this.functions.performSearch.bind(this)
            )),
          (this.functions.debouncedBuildIndex = theme.debounce(
            this.functions.buildIndex.bind(this),
            50
          )),
          this.registerEventListener(
            document,
            "theme:faq-header-update",
            this.functions.debouncedBuildIndex
          ),
          this.functions.debouncedBuildIndex(),
          this.container.querySelector(".faq-index") &&
            (this.registerEventListener(
              this.container,
              "click",
              this.functions.handleIndexClick.bind(this)
            ),
            this.container
              .closest(".section-faq-header")
              .classList.add(this.classNames.sectionWithIndexStatus),
            this.functions.resizeIndex.call(this),
            this.registerEventListener(
              window,
              "resize",
              theme.debounce(this.functions.resizeIndex.bind(this), 250)
            ));
      }),
        (this.onSectionReorder = function (e) {
          this.functions.debouncedBuildIndex();
        }),
        (this.functions = {
          buildIndex: function e() {
            var t = this.container.closest(".section-faq-header"),
              i = this.container.querySelector(".faq-index__item-container");
            i &&
              i.querySelectorAll(".faq-index-item").forEach((e) => {
                e.parentNode.removeChild(e);
              }),
              (this.linkedCollapsibleTabs = []),
              (this.linkedQuestionContainers = []),
              (this.linkedContent = []);
            for (
              var a = t;
              a.nextElementSibling &&
              a.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              if (
                ((a = a.nextElementSibling),
                this.linkedCollapsibleTabs.push(a),
                a
                  .querySelectorAll(".collapsible-tabs__tab")
                  .forEach((e) => this.linkedQuestionContainers.push(e)),
                a
                  .querySelectorAll(".collapsible-tabs__content")
                  .forEach((e) => this.linkedContent.push(e)),
                i)
              ) {
                var n = a.querySelector(".collapsible-tabs__heading");
                if (n) {
                  var o = theme.createTemplateVariableEncoder();
                  o.add("title_id", n.id, "attribute"),
                    o.add("title", n.innerHTML, "raw");
                  var s =
                      '\n              <div class="faq-index-item">\n                <a class="faq-index-item__link" href="#'
                        .concat(o.values.title_id, '">')
                        .concat(o.values.title, "</a>\n              </div>"),
                    r = document.createRange().createContextualFragment(s);
                  i.appendChild(r);
                }
              }
            i && this.functions.resizeIndex.call(this);
          },
          resizeIndex: function e() {
            for (
              var t = this.container.querySelector(
                  ".faq-index__sticky-container"
                ),
                i = this.container.closest(".section-faq-header");
              i.nextElementSibling &&
              i.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              i = i.nextElementSibling;
            var a = t.getBoundingClientRect(),
              n = i.getBoundingClientRect();
            t.style.height = n.bottom - a.top + "px";
          },
          performSearch: function e() {
            setTimeout(() => {
              var e = this.searchInput.value.split(" "),
                t = [];
              e.forEach((e) => {
                e.length > 0 && t.push(e.toLowerCase());
              }),
                this.linkedQuestionContainers.forEach((e) => {
                  if (t.length) {
                    var i = !1,
                      a = e.textContent.toLowerCase();
                    t.forEach((e) => {
                      a.indexOf(e) >= 0 && (i = !0);
                    }),
                      i
                        ? e.classList.remove(
                            this.classNames.questionContainerInactive
                          )
                        : e.classList.add(
                            this.classNames.questionContainerInactive
                          );
                  } else
                    e.classList.remove(
                      this.classNames.questionContainerInactive
                    );
                }),
                this.linkedContent.forEach((e) => {
                  t.length
                    ? e.classList.add(this.classNames.questionContainerInactive)
                    : e.classList.remove(
                        this.classNames.questionContainerInactive
                      );
                });
            }, 10);
          },
          handleIndexClick: function e(t) {
            if (t.target.classList.contains("faq-index-item__link")) {
              t.preventDefault();
              var i = t.target.href.split("#")[1],
                a =
                  document.getElementById(i).getBoundingClientRect().top +
                  window.pageYOffset -
                  50,
                n = getComputedStyle(document.documentElement).getPropertyValue(
                  "--theme-sticky-header-height"
                );
              n && (a -= parseInt(n)),
                window.scrollTo({ top: a, behavior: "smooth" });
            }
          },
        });
    })()),
    cc.sections.push({
      name: "faq-header",
      section: theme.FaqHeader,
      deferredLoad: !1,
    }),
    (theme.CollapsibleTabs = new (function () {
      (this.onSectionLoad = function (e) {
        this.functions.notifyFaqHeaderOfChange();
      }),
        (this.onSectionReorder = function (e) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.onSectionUnload = function (e) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.functions = {
          notifyFaqHeaderOfChange: function e() {
            document.dispatchEvent(
              new CustomEvent("theme:faq-header-update", {
                bubbles: !0,
                cancelable: !1,
              })
            );
          },
        });
    })()),
    cc.sections.push({
      name: "collapsible-tabs",
      section: theme.CollapsibleTabs,
      deferredLoad: !1,
    }),
    (theme.StoreAvailability = function (e) {
      var t = "store-availability-loading",
        i = "store-availability-initialized",
        a = "cc-location";
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.productId = this.$container.data(
            "store-availability-container"
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal,
          this.$container.addClass(i),
          (this.transitionDurationMS =
            1e3 * parseFloat(getComputedStyle(e).transitionDuration)),
          (this.removeFixedHeightTimeout = -1),
          $(window).on(
            "cc-variant-updated".concat(this.namespace).concat(this.productId),
            (e, t) => {
              t.product.id === this.productId &&
                this.functions.updateContent.bind(this)(
                  t.variant ? t.variant.id : null,
                  t.product.title,
                  this.$container.data("has-only-default-variant"),
                  t.variant && void 0 !== t.variant.available
                );
            }
          ),
          this.$container.data("single-variant-id") &&
            this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available")
            );
      }),
        (this.onSectionUnload = function () {
          $(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId)
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function e() {
            return new Promise((e, t) => {
              var i;
              sessionStorage[a] && (i = JSON.parse(sessionStorage[a])),
                i
                  ? e(i)
                  : navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      function (t) {
                        var i = {
                          latitude: t.coords.latitude,
                          longitude: t.coords.longitude,
                        };
                        fetch("/localization.json", {
                          method: "PUT",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(i),
                        }),
                          (sessionStorage[a] = JSON.stringify(i)),
                          e(i);
                      },
                      function () {
                        e(!1);
                      },
                      { maximumAge: 36e5, timeout: 5e3 }
                    )
                  : e(!1);
            });
          },
          getAvailableStores: function e(t, i) {
            return $.get(this.sectionUrl.replace("VARIANT_ID", t), i);
          },
          calculateDistance: function e(t, i, a) {
            var n,
              o = Math.PI / 180,
              s = "metric" === a ? 6378.14 : 3959,
              r = t.latitude * o,
              l = t.longitude * o,
              c = i.latitude * o,
              d =
                Math.pow(Math.sin((r - c) / 2), 2) +
                Math.cos(r) *
                  Math.cos(c) *
                  Math.pow(Math.sin((l - i.longitude * o) / 2), 2);
            return s * (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)));
          },
          updateLocationDistances: function e(t) {
            var i = this.$modal.find("[data-unit-system]").data("unit-system"),
              a = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var e = {
                latitude: parseFloat($(this).data("latitude")),
                longitude: parseFloat($(this).data("longitude")),
              };
              if (e.latitude && e.longitude) {
                var n = a.functions.calculateDistance(t, e, i).toFixed(1);
                $(this).html(n),
                  setTimeout(() => {
                    $(this)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              $(this).attr("data-distance", "true");
            });
          },
          updateContent: function e(i, a, n, o) {
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]"
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background"
              ),
              $(".store-availabilities-modal").remove(),
              o
                ? (this.$container.addClass(t),
                  this.transitionDurationMS > 0 &&
                    this.$container.css(
                      "height",
                      this.$container.outerHeight() + "px"
                    ))
                : (this.$container.addClass(t),
                  this.transitionDurationMS > 0 &&
                    this.$container.css("height", "0px")),
              o &&
                this.functions.getAvailableStores.call(this, i, (e) => {
                  if (e.trim().length > 0 && !e.includes("NO_PICKUP")) {
                    this.$container.html(e),
                      this.$container.html(
                        this.$container.children().first().html()
                      ),
                      this.$container
                        .find("[data-store-availability-modal-product-title]")
                        .html(a),
                      n &&
                        this.$container
                          .find(".store-availabilities-modal__variant-title")
                          .remove(),
                      this.$container.find(".cc-popup").appendTo("body"),
                      (this.$modal = $("body").find(
                        ".store-availabilities-modal"
                      ));
                    var o = new ccPopup(this.$modal, this.namespace);
                    if (
                      (this.$container.on(
                        "click",
                        "[data-store-availability-modal-open]",
                        () => (
                          o.open(),
                          this.functions.getUserLocation().then((e) => {
                            e &&
                              this.$modal.find('[data-distance="false"]')
                                .length &&
                              this.functions.getAvailableStores.call(
                                this,
                                i,
                                (t) => {
                                  this.$modal
                                    .find(".store-availabilities-list")
                                    .html(
                                      $(t)
                                        .find(".store-availabilities-list")
                                        .html()
                                    ),
                                    this.functions.updateLocationDistances.bind(
                                      this
                                    )(e);
                                }
                              );
                          }),
                          !1
                        )
                      ),
                      this.$modal.on(
                        "click" + this.namespace,
                        ".cc-popup-close, .cc-popup-background",
                        () => {
                          o.close();
                        }
                      ),
                      this.$container.removeClass(t),
                      this.transitionDurationMS > 0)
                    ) {
                      var s = this.$container
                        .find(".store-availability-container")
                        .outerHeight();
                      this.$container.css("height", s > 0 ? s + "px" : ""),
                        clearTimeout(this.removeFixedHeightTimeout),
                        (this.removeFixedHeightTimeout = setTimeout(() => {
                          this.$container.css("height", "");
                        }, this.transitionDurationMS));
                    }
                  }
                });
          },
        }),
        this.onSectionLoad(e);
    }),
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    }),
    (theme.Popup = new (function () {
      var e = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (t) {
        (this.namespace = theme.namespaceFromSection(t)),
          (this.$container = $(t)),
          (this.popup = new ccPopup(this.$container, this.namespace));
        var i = this.$container.data("dismiss-for-days"),
          a = this.$container.data("delay-seconds"),
          n = !0,
          o = this.$container.data("test-mode"),
          s = window.localStorage.getItem(e);
        s && (new Date().getTime() - s) / 864e5 < i && (n = !1),
          this.$container.find(".cc-popup-form__response").length &&
            ((n = !0),
            (a = 1),
            this.$container.find(".cc-popup-form__response--success").length &&
              this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") && (n = !1),
          (n || o) &&
            setTimeout(() => {
              this.popup.open();
            }, 1e3 * a),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            () => {
              this.popup.close(() => {
                this.functions.popupSetAsDismissed.call(this);
              });
            }
          );
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function t() {
            window.localStorage.setItem(e, new Date().getTime());
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    cc.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.owlCarouselEventList =
      "to.owl.carousel next.owl.carousel prev.owl.carousel destroy.owl.carousel initialized.owl.carousel resized.owl.carousel refreshed.owl.carousel"),
    (theme.beforeCarouselLoadEventBlockFix = function (e) {
      $(e).on(theme.owlCarouselEventList, function (e) {
        e.stopPropagation();
      });
    }),
    (theme.beforeCarouselUnloadEventBlockFix = function (e) {
      $(e).off(theme.owlCarouselEventList);
    }),
    (theme.loadCarousels = function (e) {
      return $(".carousel", e).each(function () {
        var e,
          t,
          i = $(this);
        function a() {
          var e = 0;
          return (
            i
              .find(
                i.hasClass("owl-loaded")
                  ? ".owl-item:not(.cloned)"
                  : ".product-block"
              )
              .each(function () {
                e += $(this).outerWidth(!0);
              }),
            e
          );
        }
        i.closest(".collection-slider").on(
          "click.themeCarousel",
          ".prev, .next",
          function (e) {
            e.preventDefault();
            var t = $(this)
              .closest(".collection-slider")
              .find(".owl-carousel")
              .data("owl.carousel");
            $(this).hasClass("prev") ? t.prev() : t.next();
          }
        );
        var n =
          i.hasClass("carousel--fixed-grid-mode") ||
          !$(this).closest(".container--no-max").length;
        if (n) {
          i.addClass("carousel--fixed-grid-mode");
          var o = parseInt(i[0].className.match(/per-row-(.)/)[1]),
            s = !1;
          i[0].className.indexOf("carousel--per-row-") > -1 &&
            (s = parseInt(i[0].className.match(/carousel--per-row-(.)/)[1])),
            (e = {
              margin: 0,
              loop: !1,
              autoWidth: !1,
              items: 5,
              center: !1,
              nav: !1,
              dots: !1,
              responsive: {
                0: { items: s || (o < 4 ? 1 : 2) },
                480: { items: s || Math.min(2, o - 2) },
                767: { items: s || o - 1 },
                1e3: { items: s || o },
              },
            });
        } else e = { margin: 0, loop: (t = a() > i.width()), autoWidth: !0, items: Math.min(i.children().length, 8), center: !0, nav: !1, dots: !1 };
        (e.rtl = !!document.querySelector("html[dir=rtl]")),
          i.find("[data-src]").each(function () {
            $(this)
              .attr("data-src-temp", $(this).attr("data-src"))
              .removeAttr("data-src");
          }),
          theme.beforeCarouselLoadEventBlockFix(i),
          i.on("initialized.owl.carousel", function () {
            i.find("[data-src-temp]").each(function () {
              $(this)
                .attr("data-src", $(this).attr("data-src-temp"))
                .removeAttr("data-src-temp");
            }),
              i
                .find(
                  '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual, .product-block-options__item.lazyload--manual'
                )
                .removeClass("lazyload--manual")
                .addClass("lazyload"),
              theme.ProductBlockManager.loadImages(
                i.closest("[data-section-type]")
              ),
              setTimeout(function () {
                i.data("owl.carousel").invalidate("width"),
                  i.trigger("refresh.owl.carousel");
              }, 10);
          }),
          i.on("initialized.owl.carousel resized.owl.carousel", function (o) {
            if (!n && "resized" == o.type) {
              var s = a() > i.width();
              if (s != t) {
                (e.loop = s),
                  (t = s),
                  $(o.target).data("owl.carousel").destroy(),
                  $(o.target).owlCarousel(e);
                return;
              }
            }
            setTimeout(function () {
              var e = i.find(".owl-stage").width() > i.width();
              if (e) {
                var t = 0;
                i.find(".owl-item").each(function () {
                  t += $(this).outerWidth(!0) + 1;
                }),
                  i
                    .find(".owl-stage")
                    .css({})
                    .removeClass("owl-stage--items-fit");
              } else i.find(".owl-stage").addClass("owl-stage--items-fit").css({});
              i.closest(".collection-slider")
                .find(".prev, .next")
                .toggleClass("owl-btn-disabled", !e);
            }, 10);
          }),
          (theme.carouselInputIncrementer =
            theme.carouselInputIncrementer || 0),
          i
            .on("refreshed.owl.carousel", function () {
              $(".owl-item", this).removeAttr("aria-hidden"),
                $(".owl-item.cloned", this)
                  .attr("aria-hidden", "true")
                  .each(function () {
                    theme.carouselInputIncrementer++;
                    var e = "_" + theme.carouselInputIncrementer;
                    $(this)
                      .find(
                        "form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])"
                      )
                      .each(function () {
                        $(this).attr("id", $(this).attr("id") + e);
                      })
                      .attr("data-id-altered", !0),
                      $(this)
                        .find("label[for]:not([data-id-altered])")
                        .each(function () {
                          $(this).attr("for", $(this).attr("for") + e);
                        })
                        .attr("data-id-altered", !0);
                  });
            })
            .addClass("owl-carousel")
            .owlCarousel(e);
      });
    }),
    (theme.unloadCarousels = function (e) {
      $(".collection-slider", e).off(".themeCarousel"),
        $(".slick-slider", e).slick("unslick"),
        theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", e)),
        $(".owl-carousel", e).each(function () {
          $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>' +
        theme.strings.icon_labels_left +
        '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
      chevronRight:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>' +
        theme.strings.icon_labels_right +
        '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    });
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent
    );
  } catch (e) {
    theme.Shopify.features = {};
  }
  if (
    ((theme.namespaceFromSection = function (e) {
      return [".", $(e).data("section-type"), $(e).data("section-id")].join("");
    }),
    (theme.toggleLinkDropdownButton = function (e) {
      e.stopPropagation();
      var t = $(e.currentTarget),
        i = "false" == t.attr("aria-expanded");
      t.attr("aria-expanded", i), t.css("width", t.outerWidth() + "px");
      var a = null,
        n = t.next();
      t.closest(".link-dropdown").hasClass("link-dropdown--left-aligned") ||
        (i
          ? ((a = n.outerWidth()),
            document.querySelector("html[dir=rtl]")
              ? (a += parseInt(n.css("left")))
              : (a += parseInt(n.css("right"))),
            (a -= parseInt(
              n.find(".link-dropdown__link:first").css("padding-inline-start")
            )))
          : (a =
              parseInt(t.css("padding-inline-end")) +
              t.find(".link-dropdown__button-text").width() +
              1),
        setTimeout(function () {
          t.css("width", a + "px");
        }, 10));
    }),
    (theme.awakenImagesFromSlumber = function (e) {
      e.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
    }),
    (theme.measureTextInsideElement = function (e, t) {
      theme.measureTextInsideElementCanvas =
        theme.measureTextInsideElementCanvas ||
        document.createElement("canvas");
      var i = theme.measureTextInsideElementCanvas.getContext("2d"),
        a = getComputedStyle(t).font;
      return (i.font = a), i.measureText(e);
    }),
    (theme.avoidUnecessaryOrphans = function (e) {
      if (theme.settings.avoid_orphans) {
        var t = e.innerText.split(" ");
        if (
          t.length >= 4 &&
          t[t.length - 1].length + t[t.length - 2].length < 20
        ) {
          var i = e.innerHTML;
          if (0 > i.indexOf('<span class="orphan-join">')) {
            var a = (i = i.replace(/<[^>]*?>/g, (e) =>
                e.replace(/ /g, "ΩΩ")
              )).split(" "),
              n = a.pop();
            if (
              theme.measureTextInsideElement(
                a[a.length - 1].replace(/<[^>]*?>/g, "") +
                  " " +
                  n.replace(/<[^>]*?>/g, ""),
                e
              ).width > e.clientWidth
            )
              return;
            (i = (i =
              a.join(" ") + '<span class="orphan-join"> </span>' + n).replace(
              /ΩΩ/g,
              " "
            )),
              (e.innerHTML = i);
          }
        }
      }
    }),
    (theme.stickyHeaderHeight = function () {
      var e = getComputedStyle(document.documentElement).getPropertyValue(
        "--theme-sticky-header-height"
      );
      return (e && parseInt(e)) || 0;
    }),
    (theme.getOffsetTopFromDoc = (e) =>
      e ? theme.getOffsetTopFromDoc(e.offsetParent) + e.offsetTop : 0),
    (theme.getScrollParent = function (e) {
      var t = e instanceof HTMLElement && window.getComputedStyle(e).overflowY,
        i = "visible" !== t && "hidden" !== t;
      return e
        ? i && e.scrollHeight > e.clientHeight
          ? e
          : theme.getScrollParent(e.parentNode) ||
            document.scrollingElement ||
            window
        : null;
    }),
    (theme.scrollToRevealElement = function (e) {
      var t = theme.getScrollParent(e),
        i = t === window ? window.scrollY : t.scrollTop,
        a = t === window ? window.innerHeight : t.clientHeight,
        n = theme.getOffsetTopFromDoc(e),
        o = n + e.offsetHeight,
        s = i + theme.stickyHeaderHeight(),
        r = i + a - 50;
      (n < s || o > r) &&
        t.scrollTo({
          top: n - 100 - theme.stickyHeaderHeight(),
          left: 0,
          behavior: "smooth",
        });
    }),
    (theme.getEmptyOptionSelectors = function (e) {
      var t = [];
      return (
        e
          .find('[data-selector-type="dropdown"].option-selector')
          .each(function () {
            $(this)
              .find('[aria-selected="true"]')
              .filter(function () {
                return this.dataset && this.dataset.value;
              }).length || t.push(this);
          }),
        e
          .find('[data-selector-type="listed"].option-selector')
          .each(function () {
            $(this).find("input:checked").length || t.push(this);
          }),
        t
      );
    }),
    (theme.validateProductForm = function (e) {
      if (
        (e
          .find(".option-selector--empty")
          .removeClass("option-selector--empty")
          .find(".label__prefix")
          .remove(),
        e.find(".original-selector").val())
      )
        return !!theme.OptionManager.getCurrentVariantData(e).available;
      var t = theme.getEmptyOptionSelectors(e);
      return (
        t.length &&
          (t.forEach((e) => {
            e.classList.add("option-selector--empty");
            var t = document.createElement("span");
            (t.innerText = theme.strings.products_product_pick_a + " "),
              (t.className = "label__prefix"),
              e.querySelector(".label").prepend(t);
          }),
          theme.scrollToRevealElement(t[0]),
          e.addClass("product-form--validation-started")),
        !1
      );
    }),
    (theme.pauseAllMedia = function (e) {
      (!e || e.videos) &&
        (document.querySelectorAll(".js-youtube").forEach((e) => {
          e.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
          e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause())),
        (!e || e.models) &&
          document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
          });
    }),
    (theme.suffixIds = (e, t) => {
      for (
        var i = ["id", "for", "aria-describedby", "aria-controls"],
          a = function a(n) {
            e.querySelectorAll("[".concat(i[n], "]")).forEach((e) =>
              e.setAttribute(i[n], e.getAttribute(i[n]) + t)
            );
          },
          n = 0;
        n < i.length;
        n++
      )
        a(n);
    }),
    (theme.addDelegateEventListener = function (e, t, i, a) {
      var n =
          arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
        o = (t) => {
          var n = t.target.closest(i);
          n && e.contains(n) && a.call(n, t, n);
        };
      e.addEventListener(t, o, n);
    }),
    (theme.hideAndRemove = (e) => {
      e.querySelectorAll("input").forEach((e) => (e.disabled = !0));
      var t = document.createElement("div");
      (t.className = "merge-remove-wrapper"),
        e.parentNode.insertBefore(t, e),
        t.appendChild(e),
        e.classList.add("merge-remove-item"),
        (t.style.height = t.clientHeight + "px");
      var i = getComputedStyle(e),
        a = 1e3 * parseFloat(i.getPropertyValue("--fade-duration")),
        n = 1e3 * parseFloat(i.getPropertyValue("--slide-duration"));
      setTimeout(() => {
        t.classList.add("merge-remove-wrapper--fade"),
          setTimeout(() => {
            t.classList.add("merge-remove-wrapper--slide"),
              setTimeout(() => t.remove(), n);
          }, a);
      }, 10);
    }),
    (theme.insertAndReveal = (e, t, i, a) => {
      var n = a || 10;
      e.classList.add("merge-add-wrapper"),
        t.insertAdjacentElement(i, e),
        (e.style.height = e.firstElementChild.clientHeight + "px");
      var o = getComputedStyle(e),
        s = 1e3 * parseFloat(o.getPropertyValue("--fade-duration")),
        r = 1e3 * parseFloat(o.getPropertyValue("--slide-duration"));
      setTimeout(() => {
        e.classList.add("merge-add-wrapper--slide"),
          setTimeout(() => {
            e.classList.add("merge-add-wrapper--fade"),
              setTimeout(() => {
                (e.style.height = ""),
                  e.classList.remove(
                    "merge-add-wrapper",
                    "merge-add-wrapper--slide",
                    "merge-add-wrapper--fade"
                  );
              }, s);
          }, r);
      }, n);
    }),
    (theme.mergeNodes = (e, t) => {
      try {
        e.querySelectorAll("[data-merge]").forEach((e) => {
          var i = t.querySelector(
            '[data-merge="'.concat(e.dataset.merge, '"]')
          );
          (e.dataset.mergeCache &&
            i.dataset.mergeCache &&
            e.dataset.mergeCache === i.dataset.mergeCache) ||
            ((i.innerHTML = e.innerHTML),
            (i.dataset.mergeCache = e.dataset.mergeCache));
        }),
          e.querySelectorAll("[data-merge-attributes]").forEach((e) => {
            var i = t.querySelector(
              '[data-merge-attributes="'.concat(e.dataset.mergeAttributes, '"]')
            );
            for (var a of e.attributes) i.setAttribute(a.localName, a.value);
          }),
          e.querySelectorAll("[data-merge-list]").forEach((e) => {
            var i = t.querySelector(
                '[data-merge-list="'.concat(e.dataset.mergeList, '"]')
              ),
              a = Array.from(i.querySelectorAll("[data-merge-list-item]")),
              n = Array.from(e.querySelectorAll("[data-merge-list-item]"));
            a.forEach((e) => {
              n.find(
                (t) => t.dataset.mergeListItem == e.dataset.mergeListItem
              ) || theme.hideAndRemove(e);
            }),
              (a = Array.from(
                i.querySelectorAll(
                  "[data-merge-list-item]:not(.merge-remove-item)"
                )
              ));
            for (
              var o = function e() {
                  var t = n[s],
                    o = a.find(
                      (e) => e.dataset.mergeListItem == t.dataset.mergeListItem
                    );
                  o
                    ? (t.dataset.mergeCache &&
                        o.dataset.mergeCache &&
                        t.dataset.mergeCache === o.dataset.mergeCache) ||
                      ((o.innerHTML = t.innerHTML),
                      t.dataset.mergeCache &&
                        (o.dataset.mergeCache = t.dataset.mergeCache))
                    : (0 === s
                        ? theme.insertAndReveal(t, i, "afterbegin", 500)
                        : s >= a.length
                        ? theme.insertAndReveal(t, i, "beforeend", 500)
                        : theme.insertAndReveal(t, a[s], "beforebegin", 500),
                      a.splice(s, 0, t));
                },
                s = 0;
              s < n.length;
              s++
            )
              o();
          });
      } catch (i) {
        location.reload();
      }
    }),
    (theme.lazyBGSetWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
      2700, 3e3, 3350, 3750, 4100,
    ]),
    (theme.loadLazyBGSet = function (e) {
      $("[data-lazy-bgset-src]", e).each(function () {
        for (
          var e = "",
            t = $(this).data("lazy-bgset-src"),
            i = $(this).data("lazy-bgset-aspect-ratio"),
            a = $(this).data("lazy-bgset-width"),
            n = Math.round(a / i),
            o = 0;
          o < theme.lazyBGSetWidths.length;
          o++
        ) {
          var s = theme.lazyBGSetWidths[o];
          a >= s &&
            (e += ""
              .concat(theme.Shopify.formatImage(t, s + "x"), " ")
              .concat(s, "w ")
              .concat(Math.round(s / i), "h, "));
        }
        (e += "".concat(t, " ").concat(a, "w ").concat(n, "h")),
          $(this)
            .attr("data-bgset", e)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
      });
    }),
    (theme.ProductBlockManager = new (function () {
      var e = this;
      (e.isDesktop = function () {
        return $(window).width() >= 768;
      }),
        (e.loadImages = function (t) {
          var t = t;
          void 0 === t && (t = $("body")),
            theme.loadLazyBGSet(t),
            e.isDesktop() &&
              (setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover.product-block__image--inactivated",
                  t
                ).each(function () {
                  e.lazyloadImage($(this)),
                    lazySizes.loader.unveil($(this).find(".lazyload")[0]);
                });
              }, 250),
              setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover + .product-block__image--inactivated",
                  t
                ).each(function () {
                  e.lazyloadImage($(this));
                });
              }, 1e3)),
            e.monitorImagePagination(t),
            e.monitorSwatchSelection(t),
            e.afterImagesResized(t);
        }),
        (e.unloadImages = function (e) {
          $(e).off(".productBlockManager");
        }),
        (e.getImageAt = function (e, t) {
          return e[((t % e.length) + e.length) % e.length];
        }),
        (e.lazyloadImage = function (e, t) {
          var i = e.filter(".product-block__image--inactivated");
          i.length
            ? (t &&
                i.on("lazyloaded.themeBlockManager", (e) => {
                  e.target === i.find(".lazyloaded")[0] && t(),
                    $(this).off("lazyloaded.themeBlockManager");
                }),
              i.removeClass("product-block__image--inactivated"))
            : t && t();
        }),
        (e.incrementActiveImage = function (t, i) {
          var a = Math.max(
            t.filter(".product-block__image--active:first").index(),
            0
          );
          e.setActiveImage(t, a + i);
        }),
        (e.setActiveImage = function (t, i) {
          var a = $(e.getImageAt(t, i));
          e.lazyloadImage(a, () => {
            a.addClass("product-block__image--active"),
              a.siblings().removeClass("product-block__image--active");
            var n = $(e.getImageAt(t, i + 1)).addClass(
              "product-block__image--show-on-hover"
            );
            n.siblings().removeClass("product-block__image--show-on-hover"),
              e.lazyloadImage(n);
          }),
            t
              .closest(".image-cont")
              .find(".product-block__image-dot")
              .removeClass("product-block__image-dot--active")
              .eq(a.index())
              .addClass("product-block__image-dot--active");
        }),
        (e.monitorImagePagination = function (t) {
          $(".image-cont--with-secondary-image", t).length &&
            ($(t).on(
              "click.productBlockManager",
              ".image-page-button",
              function (t) {
                var i = $(this)
                  .closest(".product-block")
                  .find(".product-block__image");
                return (
                  e.incrementActiveImage(
                    i,
                    $(t.currentTarget).hasClass("image-page-button--next")
                      ? 1
                      : -1
                  ),
                  i.each(function () {
                    e.lazyloadImage($(this));
                  }),
                  !1
                );
              }
            ),
            0 ===
              $(".image-cont--with-secondary-image:first", t).closest(
                ".carousel, .product-list--scrollarea"
              ).length &&
              ($(t).on("imageSwiped", ".product-block", function () {
                $(".product-block__image--inactivated", this).length &&
                  setTimeout(
                    function () {
                      $(this)
                        .find(".product-block__image")
                        .each(function () {
                          e.lazyloadImage($(this));
                        });
                    }.bind(this),
                    500
                  );
              }),
              $(t).on(
                "touchstart.productBlockManager",
                ".image-cont--with-secondary-image",
                function (t) {
                  (theme.productBlockTouchTracking = !0),
                    (theme.productBlockTouchStartX = t.touches[0].clientX),
                    (theme.productBlockTouchStartY = t.touches[0].clientY);
                  var i = t.currentTarget.querySelector(
                    ".product-block__image--active + .product-block__image--inactivated"
                  );
                  i && e.lazyloadImage($(i));
                }
              ),
              $(t).on(
                "touchmove.productBlockManager",
                ".image-cont--with-secondary-image",
                function (t) {
                  if (
                    theme.productBlockTouchTracking &&
                    30 >
                      Math.abs(
                        t.touches[0].clientY - theme.productBlockTouchStartY
                      )
                  ) {
                    var i =
                      t.touches[0].clientX - theme.productBlockTouchStartX;
                    if (i > 25) {
                      var a = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      e.incrementActiveImage(a, -1),
                        (theme.productBlockTouchTracking = !1);
                    } else if (i < -25) {
                      var a = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      e.incrementActiveImage(a, 1),
                        (theme.productBlockTouchTracking = !1);
                    }
                  }
                }
              ),
              $(t).on(
                "touchend.productBlockManager",
                ".image-cont--with-secondary-image",
                function (e) {
                  theme.productBlockTouchTracking = !1;
                }
              )));
        }),
        (e.monitorSwatchSelection = function (t) {
          $("[data-media].product-block-options__item", t).length &&
            $(t).on(
              "mouseenter.productBlockManager click.productBlockManager",
              "[data-media].product-block-options__item",
              function () {
                var t = $(this).closest(".product-block"),
                  i = t.find(".product-block__image"),
                  a = i
                    .filter(
                      '[data-media-id="' +
                        $(this).data("media") +
                        '"].product-block__image'
                    )
                    .index();
                e.setActiveImage(i, a);
                var n = $(this)
                    .closest(".product-block-options")
                    .data("option-name"),
                  o = $(this).data("option-item");
                t[0]
                  .querySelectorAll(".product-link, .quickbuy-toggle")
                  .forEach((e) => {
                    var t = new URL(e.href),
                      i = new URLSearchParams(t.search);
                    i.set(n, o),
                      (e.href = "".concat(t.pathname, "?").concat(i)),
                      (e.rel = "nofollow");
                  });
              }
            );
        }),
        (e.afterImagesResized = function (t) {
          var t = t;
          void 0 === t && (t = $("body")), e.alignProductBlockHeights(t);
        }),
        (e.alignProductBlockHeights = function (e) {
          var e = e;
          void 0 === e && (e = $("body")),
            $(".collection-listing .product-list", e).each(function () {
              if (
                $(window).width() >= 768 ||
                $(this).closest(".carousel").length > 0
              ) {
                var e = 0;
                $(this)
                  .find(".product-block .block-inner .block-inner-inner")
                  .each(function () {
                    $(this).height() > e && (e = $(this).height());
                  }),
                  $(this)
                    .find(".product-block .block-inner")
                    .css("min-height", e);
              } else $(this).find(".product-block .block-inner").css("min-height", "");
            });
        });
    })()),
    "notification" === theme.settings.after_add_to_cart)
  ) {
    var AddedNotification = class extends HTMLElement {
      connectedCallback() {
        this.dismissOthers(),
          this.setProductTitle(this.dataset.productTitle),
          this.display();
      }
      disconnectedCallback() {
        clearTimeout(this.delayedDismissTimeout);
      }
      dismissOthers() {
        document.querySelectorAll(".added-notification").forEach((e) => {
          e !== this && e.dismiss();
        });
      }
      setProductTitle(e) {
        this.querySelector(".added-notification__message-title").innerText = e;
      }
      display() {
        setTimeout(
          () => this.classList.remove("added-notification--hidden"),
          10
        ),
          (this.delayedDismissTimeout = setTimeout(
            this.dismiss.bind(this),
            6e3
          )),
          this.querySelector(".added-notification__close").addEventListener(
            "click",
            this.dismiss.bind(this)
          ),
          "drawer" === theme.settings.cart_type &&
            this.querySelectorAll(
              '.added-notification__message-text a[href$="/cart"]'
            ).forEach((e) => {
              e.addEventListener("click", (e) => {
                e.preventDefault(),
                  document.dispatchEvent(
                    new CustomEvent("theme:open-cart-drawer", {
                      bubbles: !0,
                      cancelable: !1,
                    })
                  ),
                  this.dismiss();
              });
            });
      }
      dismiss(e) {
        e && e.preventDefault(),
          this.classList.add("added-notification--dismissed"),
          setTimeout(this.remove.bind(this), 2e3);
      }
    };
    window.customElements.define("added-notification", AddedNotification);
  }
  (theme.applyAjaxToProductForm = function (e) {
    e.find("form.product-purchase-form").each(function () {
      var t = $(this);
      t.on("submit", function (i) {
        if (!theme.validateProductForm(e)) return !1;
        if (
          "no-js" !== theme.settings.after_add_to_cart &&
          e.is('[data-ajax-add-to-cart="true"]')
        ) {
          i.preventDefault();
          var a = theme.routes.cart_add_url;
          t.find('button[type="submit"]')
            .attr("disabled", "disabled")
            .each(function () {
              $(this).hasClass("btn--added")
                ? clearTimeout($(this).data("revertAddToCartTextTimeoutID"))
                : $(this).data("previous-value", $(this).html());
            })
            .html(
              '<div class="loading-spinner loading-spinner--in-btn"></div>'
            );
          var n = new FormData(t[0]);
          n.append("sections", "cart-drawer"),
            $.post(
              a,
              new URLSearchParams(n).toString(),
              theme.addedToCartHandler.bind(t),
              "json"
            ).fail(function (i) {
              if (
                (t
                  .find('button[type="submit"]')
                  .removeAttr("disabled")
                  .each(function () {
                    $(this).html($(this).data("previous-value"));
                  }),
                void 0 !== i && void 0 !== i.status)
              ) {
                var a = $.parseJSON(i.responseText);
                theme.showQuickPopup(
                  a.description,
                  t.find('button[type="submit"]:first')
                );
              } else e.attr("ajax-add-to-cart", "false"), t.submit();
            });
        }
      });
    });
  }),
    (theme.addedToCartHandler = function (e) {
      if ("page" === theme.settings.after_add_to_cart)
        window.location = theme.routes.cart_url;
      else if ("drawer" === theme.settings.after_add_to_cart)
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:cartchanged", {
            bubbles: !0,
            cancelable: !1,
            detail: { openDrawer: !0 },
          })
        );
      else if ("notification" === theme.settings.after_add_to_cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:cartchanged", { bubbles: !0, cancelable: !1 })
        );
        var t = document
          .getElementById("AddedNotification")
          .content.firstElementChild.cloneNode(!0);
        t.dataset.productTitle = e.product_title;
        var i = document.querySelector(".pageheader--sticky");
        i || (i = document.querySelector("body")), i.appendChild(t);
      }
      $(this)
        .find('button[type="submit"]')
        .removeAttr("disabled")
        .each(function () {
          ($btn = $(this))
            .addClass("btn--added")
            .text(theme.strings.products_product_added_to_cart),
            clearTimeout($(this).data("revertAddToCartTextTimeoutID")),
            $btn.data(
              "revertAddToCartTextTimeoutID",
              setTimeout(function () {
                $btn
                  .html($btn.data("previous-value"))
                  .removeClass("btn--added");
              }, 3e3)
            );
        });
    }),
    (theme.removeAjaxFromProductForm = function (e) {
      e.find("form.product-purchase-form").off("submit");
    });
  var CartForm = class extends HTMLElement {
    connectedCallback() {
      theme.cartNoteMonitor.load($('[name="note"]', this)),
        (this.enableAjaxUpdate = this.dataset.ajaxUpdate),
        this.enableAjaxUpdate &&
          ((this.sectionId = this.dataset.sectionId),
          (this.boundRefresh = (e) => {
            this.refresh(e.detail && e.detail.openDrawer);
          }),
          document.addEventListener("theme:cartchanged", this.boundRefresh),
          theme.addDelegateEventListener(
            this,
            "click",
            ".cart-item__remove",
            (e) => {
              e.preventDefault(),
                this.adjustItemQuantity(e.target.closest(".cart-item"), {
                  to: 0,
                });
            }
          ),
          theme.addDelegateEventListener(
            this,
            "click",
            ".quantity-down",
            (e) => {
              e.preventDefault(),
                this.adjustItemQuantity(e.target.closest(".cart-item"), {
                  decrease: !0,
                });
            }
          ),
          theme.addDelegateEventListener(this, "click", ".quantity-up", (e) => {
            e.preventDefault(),
              this.adjustItemQuantity(e.target.closest(".cart-item"), {
                increase: !0,
              });
          }),
          theme.addDelegateEventListener(
            this,
            "change",
            ".cart-item__quantity-input",
            (e) => {
              this.adjustItemQuantity(e.target.closest(".cart-item"), {
                currentValue: !0,
              });
            }
          ));
    }
    disconnectedCallback() {
      theme.cartNoteMonitor.unload($('[name="note"]', this)),
        this.enableAjaxUpdate &&
          document.removeEventListener("theme:cartchanged", this.boundRefresh);
    }
    refresh(e) {
      this.classList.add("cart-form--refreshing"),
        fetch(
          ""
            .concat(window.Shopify.routes.root, "?section_id=")
            .concat(this.sectionId)
        )
          .then((e) => {
            if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
            return e.text();
          })
          .then((t) => {
            var i = document.createDocumentFragment(),
              a = document.createElement("div");
            i.appendChild(a),
              (a.innerHTML = t),
              a
                .querySelectorAll("[data-cc-animate]")
                .forEach((e) => e.removeAttribute("data-cc-animate")),
              theme.mergeNodes(a, this),
              this.classList.remove("cart-form--refreshing"),
              this.querySelectorAll(".merge-item-refreshing").forEach((e) =>
                e.classList.remove("merge-item-refreshing")
              ),
              theme.cartNoteMonitor.load($('[name="note"]', this)),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
          });
    }
    adjustItemQuantity(e, t) {
      var i = e.querySelector(".cart-item__quantity-input"),
        a = parseInt(i.value);
      void 0 !== t.to
        ? ((a = t.to), (i.value = a))
        : t.increase
        ? ((a += i.step || 1), (i.value = a))
        : t.decrease
        ? ((a -= i.step || 1), (i.value = a))
        : t.currentValue,
        i.max &&
          parseInt(i.value) > parseInt(i.max) &&
          ((a = i.max),
          (i.value = a),
          theme.showQuickPopup(
            theme.strings.cart_general_quantity_too_high.replace(
              "[QUANTITY]",
              i.max
            ),
            $(i)
          )),
        clearTimeout(this.adjustItemQuantityTimeout),
        (this.adjustItemQuantityTimeout = setTimeout(
          () => {
            var e = [];
            this.querySelectorAll(
              ".cart-item__quantity-input:not([disabled])"
            ).forEach((t) => {
              e.push(t.value),
                t.value != t.dataset.initialValue &&
                  t
                    .closest("[data-merge-list-item]")
                    .classList.add("merge-item-refreshing");
            }),
              fetch(theme.routes.cart_update_url, {
                method: "POST",
                body: JSON.stringify({ updates: e }),
                headers: { "Content-Type": "application/json" },
              }).then((e) => {
                if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
                document.dispatchEvent(
                  new CustomEvent("theme:cartchanged", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
              });
          },
          0 === a ? 10 : 700
        ));
    }
  };
  window.customElements.define("cart-form", CartForm);
  var CCCartCrossSell = class extends HTMLElement {
    connectedCallback() {
      setTimeout(this.init.bind(this), 500);
    }
    init() {
      (this.productList = this.querySelector(".product-list")),
        this.dataset.from
          ? fetch(this.dataset.from)
              .then((e) => {
                if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
                return e.text();
              })
              .then((e) => {
                var t = document.createDocumentFragment(),
                  i = document.createElement("div");
                t.appendChild(i), (i.innerHTML = e);
                var a = i.querySelector(".product-list");
                a
                  ? ((this.productList.innerHTML = a.innerHTML),
                    theme.loadCarousels(this))
                  : this.classList.add("hidden");
              })
          : theme.loadCarousels(this);
    }
  };
  window.customElements.define("cc-cart-cross-sell", CCCartCrossSell);

  // Checkpoint start

  // Custom Colorways

  var CCCustomColorways = class extends HTMLElement {
    connectedCallback() {
      setTimeout(this.init.bind(this), 500);
    }
    init() {

      // theme.loadCarousels(this);
    }
  };
  window.customElements.define("cc-custom-colorways", CCCustomColorways);

  // Custom Colorways

  // Checkpoint end
  var CCFetchedContent = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((e) => {
          if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
          return e.text();
        })
        .then((e) => {
          var t = document.createDocumentFragment(),
            i = document.createElement("div");
          t.appendChild(i), (i.innerHTML = e);
          var a = i.querySelector(
            '[data-id="'.concat(CSS.escape(this.dataset.id), '"]')
          );
          a &&
            ((this.innerHTML = a.innerHTML),
            this.hasAttribute("contains-product-blocks") &&
              (theme.loadCarousels(this),
              theme.ProductBlockManager.loadImages(this)));
        });
    }
  };
  window.customElements.define("cc-fetched-content", CCFetchedContent),
    (theme.LoadFilterer = function (e) {
      if (
        ((this.$container = e.$container),
        (this.namespace = e.namespace),
        (this.registerEventListener = e.registerEventListener),
        (this.functions = {
          initFiltersEtc: function e() {
            $(".filter-container", this.$container).addClass(
              "filter-container--mobile-initialised"
            ),
              location.href.indexOf("?") >= 0 &&
                $(
                  "#sort-dropdown-options .link-dropdown__link",
                  this.$container
                ).each(function () {
                  var e = location.href.split("?")[1].split("&"),
                    t = $(this).attr("href");
                  e.forEach((e) => {
                    -1 === e.indexOf("sort_by=") && (t += "&" + e);
                  }),
                    $(this).attr("href", t);
                }),
              theme.ProductBlockManager.loadImages(this.$container);
          },
          switchGridLayout: function e(t) {
            t.preventDefault(),
              $(t.currentTarget).hasClass("layout-switch--one-column")
                ? this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-2")
                    .addClass("product-list--per-row-mob-1")
                : this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-1")
                    .addClass("product-list--per-row-mob-2"),
              $(t.currentTarget)
                .addClass("layout-switch--active")
                .siblings()
                .removeClass("layout-switch--active");
          },
          checkStickyScroll: function e() {
            var t = $(".utility-bar").offset().top;
            768 > $(window).width() &&
            this.previousScrollTop > window.scrollY &&
            window.scrollY > t
              ? $("body").addClass("utility-bar-sticky-mobile-copy-reveal")
              : $("body.utility-bar-sticky-mobile-copy-reveal").removeClass(
                  "utility-bar-sticky-mobile-copy-reveal"
                ),
              (this.previousScrollTop = window.scrollY);
          },
          ajaxLoadLink: function e(t) {
            t.preventDefault(),
              this.functions.ajaxLoadUrl.call(
                this,
                $(t.currentTarget).attr("href")
              );
          },
          ajaxLoadForm: function e(t) {
            "submit" === t.type && t.preventDefault();
            var i = [];
            t.currentTarget.querySelectorAll("input, select").forEach((e) => {
              (("checkbox" !== e.type && "radio" !== e.type) || e.checked) &&
                "" !== e.value &&
                i.push([e.name, encodeURIComponent(e.value)]);
            });
            var a = location.pathname;
            i.forEach((e) => {
              a += "&".concat(e[0], "=").concat(e[1]);
            }),
              (a = a.replace("&", "?")),
              this.functions.ajaxLoadUrl.call(this, a);
          },
          ajaxPopState: function e(t) {
            this.functions.ajaxLoadUrl.call(this, document.location.href, !0);
          },
          ajaxLoadUrl: function e(t, i) {
            if (!i) {
              var a = t;
              "/" === a.slice(0, 1) &&
                (a =
                  window.location.protocol + "//" + window.location.host + a),
                window.history.pushState({ path: a }, "", a);
            }
            this.$container[0].dataset.filterSectionId &&
              (t +=
                (t.indexOf("?") >= 0 ? "&" : "?") +
                "section_id=".concat(
                  this.$container[0].dataset.filterSectionId
                ));
            var n = "[data-ajax-container]",
              o = this.$container.find(n);
            o.addClass("ajax-loading"),
              this.currentAjaxLoadUrlFetch &&
                this.currentAjaxLoadUrlFetch.abort(),
              (this.currentAjaxLoadUrlFetch = $.get(
                t,
                function (e) {
                  (this.currentAjaxLoadUrlFetch = null),
                    document.activeElement &&
                      (this.activeElementId = document.activeElement.id),
                    theme.ProductBlockManager.unloadImages(this.$container);
                  var t = this.$container[0].querySelector(".filters"),
                    i = null;
                  if ("auto" === getComputedStyle(t).overflow) {
                    for (
                      var a = t.querySelectorAll(".filters *"), s = a[0], r = 1;
                      r < a.length;
                      r++
                    )
                      if (a[r].offsetTop) {
                        if (a[r].offsetTop < t.scrollTop)
                          a[r].offsetTop > s.offsetTop && (s = a[r]);
                        else break;
                      }
                    if (0 === s.offsetTop) s = !1;
                    else
                      for (var l of ((i = {
                        selector: "",
                        textContent: s.textContent,
                        extraScrollOffset: t.scrollTop - s.offsetTop,
                      }),
                      s.getAttributeNames()))
                        "class" === l
                          ? Array.from(s.classList)
                              .filter(
                                (e) => "filter-group__item--disabled" !== e
                              )
                              .forEach((e) => {
                                i.selector += "." + e;
                              })
                          : (i.selector += "["
                              .concat(l, '="')
                              .concat(CSS.escape(s.getAttribute(l)), '"]'));
                  }
                  $("<div>".concat(e, "</div>"))
                    .find(n)
                    .each(function (e) {
                      $(o[e]).html($(this).html());
                    }),
                    this.functions.initFiltersEtc.call(this),
                    i &&
                      this.$container[0]
                        .querySelectorAll(i.selector)
                        .forEach((e) => {
                          e.textContent === i.textContent &&
                            (t.scrollTop = e.offsetTop + i.extraScrollOffset);
                        });
                  var c = this.$container.closest("[data-components]");
                  if (
                    (c.length &&
                      c
                        .data("components")
                        .split(",")
                        .forEach(
                          function (e) {
                            $(document).trigger("cc:component:load", [e, c[0]]);
                          }.bind(this)
                        ),
                    o.removeClass("ajax-loading"),
                    document.dispatchEvent(
                      new CustomEvent("theme:content:loaded", {
                        detail: { container: this.$container[0] },
                      })
                    ),
                    theme.initAnimateOnScroll(),
                    this.activeElementId)
                  ) {
                    var d = document.getElementById(this.activeElementId);
                    d && d.focus();
                  }
                  var h =
                    $("[data-ajax-scroll-to]:first", this.$container).offset()
                      .top - $(".section-header").height();
                  window.scrollTo({ top: h, behavior: "smooth" });
                }.bind(this)
              ));
          },
        }),
        (this.allowAutoApplyHideUnavailable = this.$container
          .find(".filters")
          .data("auto-apply-hide-unavailable")),
        this.allowAutoApplyHideUnavailable &&
          (this.$container.on(
            "change" + this.namespace,
            ".filter-group__checkbox, .cc-price-range__input",
            (e) => {
              if (
                this.allowAutoApplyHideUnavailable &&
                (("checkbox" === e.currentTarget.type &&
                  e.currentTarget.checked) ||
                  ("text" === e.currentTarget.type && e.currentTarget.value))
              ) {
                var t = this.$container.find(
                  '[name="filter.v.availability"][value="1"]'
                )[0];
                t &&
                  ((t.checked = !0),
                  t.dispatchEvent(
                    new CustomEvent("change", { bubbles: !0, cancelable: !1 })
                  ));
              }
            }
          ),
          this.$container.on(
            "change" + this.namespace,
            ".filter-group--availability .filter-toggle__input",
            (e) => {
              e.currentTarget.checked &&
                "1" == e.currentTarget.value &&
                (this.allowAutoApplyHideUnavailable = !1);
            }
          )),
        this.$container.data("ajax-filtering")
          ? (this.$container.on(
              "click" + this.namespace,
              ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
              this.functions.ajaxLoadLink.bind(this)
            ),
            this.$container.on(
              "change" + this.namespace + " submit" + this.namespace,
              "#CollectionFilterForm",
              theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
            ),
            this.registerEventListener(
              window,
              "popstate",
              this.functions.ajaxPopState.bind(this)
            ))
          : this.$container.on(
              "change" + this.namespace,
              "#CollectionFilterForm",
              function () {
                $(this).submit();
              }
            ),
        this.$container.on(
          "click" + this.namespace,
          ".link-dropdown__button",
          theme.toggleLinkDropdownButton.bind(this)
        ),
        $(document).on("click" + this.namespace, function () {
          $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
        }),
        document.querySelector(".utility-bar"))
      ) {
        var t = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        theme.suffixIds(t[0], "dupe"),
          (this.previousScrollTop = window.scrollY),
          $(window).on(
            "throttled-scroll" + this.namespace,
            this.functions.checkStickyScroll.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (e) {
              var t = $(".filter-container", this.$container)
                .toggleClass(
                  "filter-container--show-filters-desktop filter-container--show-filters-mobile"
                )
                .hasClass("filter-container--show-filters-desktop");
              return (
                $(
                  ".toggle-btn[data-toggle-filters]",
                  this.$container
                ).toggleClass("toggle-btn--revealed-desktop", t),
                theme.ProductBlockManager.afterImagesResized(),
                $(".slick-slider", this.$container).each(function () {
                  $(this).slick("setPosition");
                }),
                !1
              );
            }.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            ".layout-switch",
            this.functions.switchGridLayout.bind(this)
          );
      }
      this.functions.initFiltersEtc.call(this),
        (this.destroy = function () {
          theme.ProductBlockManager.unloadImages(this.$container),
            theme.destroyProductGallery(this.$container),
            this.$container.off(this.namespace),
            $(window).off(this.namespace),
            $(document).off(this.namespace);
        }.bind(this));
    }),
    (theme.buildGalleryViewer = function (e) {
      for (
        var t = $('<div class="gallery-viewer gallery-viewer--pre-reveal">'),
          i = $('<div class="gallery-viewer__zoom-container">').appendTo(t),
          a = $('<div class="gallery-viewer__thumbs">').appendTo(t),
          n = $('<div class="gallery-viewer__controls">').appendTo(t),
          o = $(
            '<a class="gallery-viewer__button gallery-viewer__close" href="#">'
          )
            .html(e.close)
            .appendTo(n),
          s =
            ($(
              '<a class="gallery-viewer__button gallery-viewer__prev" href="#">'
            )
              .html(e.prev)
              .appendTo(n),
            $(
              '<a class="gallery-viewer__button gallery-viewer__next" href="#">'
            )
              .html(e.next)
              .appendTo(n),
            null),
          r = -0.001,
          l = 0.003,
          c = 1,
          d = { panX: 0, panY: 0, zoom: 1 },
          h = 0;
        h < e.images.length;
        h++
      ) {
        var u = e.images[h];
        $('<a class="gallery-viewer__thumb" href="#">')
          .data("zoom-url", u.zoomUrl)
          .html(u.thumbTag)
          .appendTo(a);
      }
      1 === e.images.length && t.addClass("gallery-viewer--single-image");
      var p = function e(i, a) {
          var n = s.width() > t.width(),
            o = s.height() > t.height();
          if (n || o) {
            var r = t.width() / 2,
              l = t.height() / 2,
              c = i - r,
              h = a - l,
              u = 0,
              p = 0;
            n && (u = Math.round(-c * ((s.width() - t.width()) / 2 / r))),
              o && (p = Math.round(-h * ((s.height() - t.height()) / 2 / l))),
              (d.panX = u),
              (d.panY = p),
              f(0, 0),
              v();
          }
        },
        f = function e(i, a) {
          d.panX += i;
          var n = (s[0].naturalWidth * d.zoom - t.width()) / 2;
          (n = Math.max(n, 0)),
            (d.panX = Math.min(d.panX, n)),
            (d.panX = Math.max(d.panX, -n)),
            (d.panY += a);
          var o = (s[0].naturalHeight * d.zoom - t.height()) / 2;
          (o = Math.max(o, 0)),
            (d.panY = Math.min(d.panY, o)),
            (d.panY = Math.max(d.panY, -o)),
            v();
        },
        m = function e(t, i, a) {
          (d.panX = t), (d.panY = i), (d.zoom = a), g(0);
        },
        g = function e(i) {
          d.zoom += i;
          var a = t.width() / s[0].naturalWidth,
            n = t.height() / s[0].naturalHeight;
          (d.zoom = Math.max(d.zoom, Math.min(a, n))),
            (d.zoom = Math.min(d.zoom, 1)),
            f(0, 0),
            v();
        },
        v = function e() {
          s.css(
            "transform",
            "translate3d("
              .concat(d.panX, "px, ")
              .concat(d.panY, "px, 0) scale(")
              .concat(d.zoom, ")")
          );
        };
      t.on(
        "click.galleryViewer select.galleryViewer",
        ".gallery-viewer__thumb",
        function (e) {
          e.preventDefault(),
            $(this)
              .addClass("gallery-viewer__thumb--active")
              .siblings(".gallery-viewer__thumb--active")
              .removeClass("gallery-viewer__thumb--active"),
            i.addClass("gallery-viewer__zoom-container--loading"),
            (s = $(
              '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">'
            ))
              .on("load", function () {
                $(this)
                  .parent()
                  .removeClass("gallery-viewer__zoom-container--loading"),
                  $(this).off("load"),
                  $(this).css({
                    visibility: "",
                    top: t.height() / 2 - $(this).height() / 2,
                    left: t.width() / 2 - $(this).width() / 2,
                  }),
                  m(0, 0, 0);
              })
              .attr("src", $(this).data("zoom-url")),
            i.html(s);
        }
      );
      var y = { isTracking: !1, lastPinchDistance: 0 },
        b = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 };
      t.on("touchend.galleryViewer", function (e) {
        (y.isTracking = !1), (b.isTracking = !1);
      }),
        t.on("mousemove.galleryViewer touchmove.galleryViewer", function (e) {
          if (
            (e.preventDefault(), "touchmove" === e.type && e.touches.length > 0)
          ) {
            var t = e.touches[0];
            if (
              (b.isTracking
                ? (f(
                    (t.clientX - b.lastTouchX) * c,
                    (t.clientY - b.lastTouchY) * c
                  ),
                  (b.lastTouchX = t.clientX),
                  (b.lastTouchY = t.clientY))
                : ((b.isTracking = !0),
                  (b.lastTouchX = t.clientX),
                  (b.lastTouchY = t.clientY)),
              2 === e.touches.length)
            ) {
              var i = e.touches[1],
                a = Math.sqrt(
                  Math.pow(t.clientX - i.clientX, 2) +
                    Math.pow(t.clientY - i.clientY, 2)
                );
              y.isTracking
                ? (g((a - y.lastPinchDistance) * l), (y.lastPinchDistance = a))
                : ((y.lastPinchDistance = a), (y.isTracking = !0));
            } else y.isTracking = !1;
          } else p(e.clientX, e.clientY);
        }),
        t.on("wheel.galleryViewer", function (e) {
          e.preventDefault(),
            0 != e.originalEvent.deltaY && g(e.originalEvent.deltaY * r);
        }),
        t.on(
          "touchmove.galleryViewer",
          ".gallery-viewer__thumbs",
          function (e) {
            e.stopPropagation();
          }
        ),
        t.on("click.galleryViewer", ".gallery-viewer__next", function (e) {
          e.preventDefault();
          var t = a.find(".gallery-viewer__thumb--active").next();
          0 === t.length && (t = a.find(".gallery-viewer__thumb:first")),
            t.trigger("select");
        }),
        t.on("click.galleryViewer", ".gallery-viewer__prev", function (e) {
          e.preventDefault();
          var t = a.find(".gallery-viewer__thumb--active").prev();
          0 === t.length && (t = a.find(".gallery-viewer__thumb:last")),
            t.trigger("select");
        }),
        t.on("click.galleryViewer", ".gallery-viewer__close", function (e) {
          e.preventDefault(), theme.galleryViewerFunctions.close();
        }),
        document.addEventListener(
          "keyup",
          theme.galleryViewerFunctions.onDocumentKeyup
        ),
        t.on(
          "click.galleryViewer",
          ".gallery-viewer__zoom-container",
          function (e) {
            e.preventDefault(),
              1 == d.zoom
                ? ((d.zoom = 0), g(0))
                : ((d.zoom = 1), g(0), p(e.clientX, e.clientY));
          }
        ),
        $("html").removeClass("gallery-viewer-open"),
        $(".gallery-viewer").remove(),
        $("html").addClass("gallery-viewer-open"),
        t.appendTo("body");
      var w = 0;
      e.currentImage &&
        e.images.forEach((t, i) => {
          e.currentImage === t.zoomUrl && (w = i);
        });
      var k = a.find(".gallery-viewer__thumb:eq(" + w + ")").trigger("select");
      e.images.length > 1 ? k.focus() : o.focus(),
        setTimeout(function () {
          t.removeClass("gallery-viewer--pre-reveal");
        }, 10);
    }),
    (theme.galleryViewerFunctions = {
      close: function e() {
        var t = $(".gallery-viewer");
        t.off(".galleryViewer"),
          document.removeEventListener(
            "keyup",
            theme.galleryViewerFunctions.onDocumentKeyup
          ),
          t.addClass("gallery-viewer--transition-out");
        var i = t.css("transition-duration");
        (i = i.indexOf("ms") > -1 ? parseFloat(i) : 1e3 * parseFloat(i)),
          setTimeout(function () {
            t.remove(), $("html").removeClass("gallery-viewer-open");
          }, i);
      },
      onDocumentKeyup: function e(t) {
        switch (t.key) {
          case "Escape":
            theme.galleryViewerFunctions.close();
            break;
          case "ArrowLeft":
            $(".gallery-viewer__prev").trigger("click");
            break;
          case "ArrowRight":
            $(".gallery-viewer__next").trigger("click");
        }
      },
    }),
    (theme.Navigation = {
      init: function e(t) {
        if (0 != t.nav.length) {
          var i = t.nav,
            a = 250,
            n = $(),
            o = -1,
            s = $(t.mobileNavHtml),
            r = $('<div class="mobile-navigation-drawer__footer">').appendTo(s);
          r.append(
            $(".announcement-bar .inline-menu")
              .clone()
              .removeClass("desktop-only")
          ),
            r.append(
              $(".announcement-bar .header-disclosures")
                .clone()
                .removeClass("desktop-only")
            );
          var l = $(".announcement-bar .social-links")
              .clone()
              .removeClass("desktop-only")[0],
            c = document.querySelector(
              ".announcement-bar .js-replacement-custom-icon"
            );
          c &&
            (l.querySelector(".social-custom").parentElement.innerHTML =
              c.content.firstElementChild.cloneNode(!0).innerHTML),
            r.append(l),
            theme.suffixIds(s[0], "MobileNav"),
            s.insertAfter($("#shopify-section-header")),
            s.on(
              "click",
              ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
              function (e) {
                e.preventDefault(),
                  $(this)
                    .parent()
                    .addClass("navigation__item--open")
                    .closest(".mobile-navigation-drawer")
                    .addClass("mobile-navigation-drawer--child-open")
                    .find(".mobile-nav-title")
                    .text($(this).siblings(".navigation__link").text()),
                  $(this)
                    .siblings(".navigation__tier-2-container")
                    .css({
                      top:
                        Math.ceil(
                          $(".navigation__mobile-header:last").height() + 1
                        ) + "px",
                    }),
                  this.closest(".mobile-navigation-drawer").scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
              }
            ),
            s.data("mobile-expand-with-entire-link") &&
              s.on(
                "click",
                ".navigation__item--with-children > .navigation__link",
                function (e) {
                  e.preventDefault(),
                    $(this)
                      .siblings(".navigation__children-toggle")
                      .trigger("click");
                }
              ),
            s.on("click", ".mobile-nav-back", function (e) {
              e.preventDefault(),
                $(this)
                  .closest(".mobile-navigation-drawer")
                  .removeClass("mobile-navigation-drawer--child-open")
                  .find(".navigation__tier-1 > .navigation__item--open")
                  .removeClass("navigation__item--open");
            }),
            s.on(
              "click",
              ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
              function (e) {
                if (
                  (e.preventDefault(),
                  $(this).parent().hasClass("navigation__item--open"))
                )
                  $(this).parent().removeClass("navigation__item--open"),
                    $(this)
                      .siblings(".navigation__tier-3-container")
                      .css("height", "");
                else {
                  $(this).parent().addClass("navigation__item--open");
                  var t = $(this).siblings(".navigation__tier-3-container");
                  t.css("height", t.children().outerHeight());
                }
              }
            ),
            i
              .find(".lazyload--manual")
              .removeClass("lazyload--manual")
              .addClass("lazyload"),
            i.on(
              "mouseenter mouseleave",
              ".navigation__tier-1 > .navigation__item--with-children",
              function (e, t) {
                var i = $(this);
                if ("mouseenter" == e.type) {
                  clearTimeout(o), clearTimeout(i.data("navCloseTimeoutId"));
                  var s = i.siblings(".navigation__item--show-children");
                  s.not(n).removeClass("navigation__item--show-children"),
                    (n = i);
                  var r = 0 == s.length ? 0 : a,
                    l = setTimeout(function () {
                      i
                        .addClass("navigation__item--show-children")
                        .siblings(".navigation__item--show-children")
                        .removeClass("navigation__item--show-children"),
                        i
                          .closest(".section-header")
                          .addClass("section-header--nav-open");
                    }, r);
                  (o = l), i.data("navOpenTimeoutId", l);
                } else
                  clearTimeout(i.data("navOpenTimeoutId")),
                    i.data(
                      "navCloseTimeoutId",
                      setTimeout(function () {
                        i.removeClass("navigation__item--show-children"),
                          i
                            .closest(".section-header")
                            .removeClass("section-header--nav-open");
                      }, a)
                    );
                i.children("[aria-expanded]").attr(
                  "aria-expanded",
                  "mouseenter" == e.type
                );
              }
            );
          var d = function e(t) {
            if ($(window).width() > 767) {
              if ("touchstart" == t.type)
                $(this).data("touchstartedAt", t.timeStamp);
              else if ("touchend" == t.type) {
                if (t.timeStamp - $(this).data("touchstartedAt") < 1e3)
                  return (
                    $(this).data("touchOpenTriggeredAt", t.timeStamp),
                    $(this).parent().hasClass("navigation__item--show-children")
                      ? $(this).parent().trigger("mouseleave")
                      : ($(
                          ".navigation:first .navigation__item--show-children"
                        ).trigger("mouseleave"),
                        $(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                "click" == t.type &&
                $(this).data("touchOpenTriggeredAt") &&
                t.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          };
          i.on(
            "touchstart touchend click",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            d
          );
          var h = function e(t) {
            if (13 == t.which) {
              var i = $(this).parent();
              return (
                i.trigger(
                  i.hasClass("navigation__item--show-children")
                    ? "mouseleave"
                    : "mouseenter"
                ),
                !1
              );
            }
          };
          i.on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            h
          ),
            t.proxyTier1Nav &&
              ($(t.proxyTier1Nav).on(
                "mouseenter touchstart",
                ".navigation__item--with-small-menu",
                function (e) {
                  var t = $(
                    $(".navigation__tier-1 > .navigation__item", i)[
                      $(this).index()
                    ]
                  ).find(".navigation__tier-2-container");
                  document.querySelector("html[dir=rtl]")
                    ? t.css(
                        "right",
                        t[0].offsetParent.clientWidth -
                          ($(this).offset().left + this.clientWidth)
                      )
                    : t.css("left", $(this).offset().left);
                }
              ),
              $(t.proxyTier1Nav)
                .on(
                  "mouseenter mouseleave",
                  ".navigation__tier-1 > .navigation__item--with-children",
                  function (e) {
                    $(
                      $(".navigation__tier-1 > .navigation__item", i)[
                        $(this).index()
                      ]
                    ).trigger(e.type);
                  }
                )
                .on(
                  "touchstart touchend click",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
                  function (e) {
                    if (
                      !1 ===
                      d.call(
                        $(
                          $(".navigation__tier-1 > .navigation__item", i)[
                            $(this).parent().index()
                          ]
                        ).children(".navigation__link")[0],
                        e
                      )
                    )
                      return !1;
                  }
                )
                .on(
                  "keydown",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
                  function (e) {
                    if (13 == e.which)
                      return (
                        h.call(
                          $(
                            $(".navigation__tier-1 > .navigation__item", i)[
                              $(this).parent().index()
                            ]
                          ).children(".navigation__children-toggle")[0],
                          e
                        ),
                        !1
                      );
                  }
                )),
            i.on(
              "click",
              '.navigation__link[href="#"][aria-haspopup="true"]',
              function () {
                return (
                  $(this)
                    .siblings(".navigation__children-toggle")
                    .trigger("click"),
                  !1
                );
              }
            ),
            i[0].addEventListener("mouseenter", theme.Navigation.onNavHover),
            i[0].addEventListener("mouseleave", theme.Navigation.onNavHover),
            t.proxyTier1Nav.length &&
              (t.proxyTier1Nav[0].addEventListener(
                "mouseenter",
                theme.Navigation.onNavHover
              ),
              t.proxyTier1Nav[0].addEventListener(
                "mouseleave",
                theme.Navigation.onNavHover
              ));
        }
      },
      onNavHover: function e(t) {
        $(t.target)
          .closest(".section-header")
          .toggleClass("section-header--nav-hover", "mouseenter" === t.type);
      },
      destroy: function e(t, i) {
        t.add(i).off("click mouseenter mouseleave touchstart touchend keydown"),
          theme.ProductBlockManager.unloadImages(
            $(".mobile-navigation-drawer .product-list")
          ),
          $(".mobile-navigation-drawer").off("click").remove();
      },
    }),
    (theme.initProductGallery = function (e) {
      var t = $(".gallery", e);
      if (!t.hasClass("gallery-initialised")) {
        if (
          (t.addClass("gallery-initialised"),
          t.data("variant-image-grouping") &&
            "" !== t.data("variant-image-grouping-option-index"))
        ) {
          var i = theme.OptionManager.getProductData(
              t.closest(".product-detail").find(".product-form")
            ),
            a = t.data("variant-image-grouping-option-index"),
            n = {};
          i.media.forEach((e) => {
            i.variants.forEach((t) => {
              t.featured_media &&
                t.featured_media.id == e.id &&
                !n[t.options[a]] &&
                (n[t.options[a]] = e.id);
            });
          });
          var o = "";
          t.find(".slide").each(function (e, t) {
            for (var i in n) $(t).data("media-id") == n[i] && (o = i);
            $(t).attr("data-variant-image-group", o);
          }),
            (o = ""),
            t.find(".thumbnail").each(function (e, t) {
              for (var i in n) $(t).data("media-id") == n[i] && (o = i);
              $(t).attr("data-variant-image-group", o);
            });
        }
        var s = $(".product-slideshow", e);
        if (s.length) {
          var r = {
            autoplay: !1,
            fade: !1,
            infinite: !1,
            useTransform: !0,
            dots: !1,
            arrows: !1,
            waitForAnimate: !1,
            appendArrows: s
              .siblings(".slideshow-controls")
              .find(".slideshow-controls__arrows"),
            prevArrow:
              '<button type="button" class="slick-product-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="slick-product-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            mobileFirst: !0,
            rtl: !!document.querySelector("html[dir=rtl]"),
            responsive: [
              { breakpoint: 768, settings: { fade: !0, arrows: !0 } },
            ],
          };
          if (
            (s
              .on("init", function (e, t) {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .on("beforeChange", function (e, t, i, a) {
                var n = $(t.$slides[a]).data("media-id");
                $(
                  $(this)
                    .closest(".gallery")
                    .find(
                      '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                        n +
                        '"]'
                    )
                ).trigger("selectFromSlick");
              }),
            s.closest(
              ".gallery--layout-carousel-beside, .gallery--layout-carousel-under"
            ).length)
          )
            s.slick(r);
          else {
            var l = function e() {
              768 > $(window).width()
                ? s.not(".slick-slider").each(function () {
                    $(this)
                      .find(".slide--inactive-option")
                      .removeClass("slide--inactive-option"),
                      $(this).slick(r),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  })
                : s.filter(".slick-slider").each(function () {
                    $(this).slick("slickUnfilter").slick("unslick"),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  });
            };
            l(), $(window).on("debouncedresize.productGallery", l);
          }
          theme.ProductMedia.init(t, {
            onYoutubeInit: function e(t) {
              s.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  s.slick("getSlick").$slides,
                  s.slick("getSlick").currentSlide
                );
            },
            onModelViewerInit: function e(t) {
              s.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  s.slick("getSlick").$slides,
                  s.slick("getSlick").currentSlide
                );
            },
            onVideoVisible: function e(t) {
              $(window).width() >= 768 &&
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1);
            },
            onModelViewerPlay: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !1),
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !1);
            },
            onModelViewerPause: function e(t) {
              $(t.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !0),
                $(t.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !0);
            },
          }),
            s.hasClass("slick-slider") &&
              theme.productGallerySlideshowTabFix(
                s.slick("getSlick").$slides,
                s.slick("getSlick").currentSlide
              ),
            s.on("afterChange", function (e, t, i) {
              theme.pauseAllMedia(),
                $(window).width() >= 768 && t.slickSetOption("swipe", !0),
                $(".product-media", t.$slides[i]).trigger("mediaVisible"),
                theme.productGallerySlideshowTabFix(t.$slides, i);
            });
        }
        var c = $(".thumbnails:not(.hidden)", e);
        if (c.length) {
          var d = 6,
            h = !1,
            u = function e() {
              "flex" == c.parent().css("display")
                ? h &&
                  ((h = !1),
                  theme.beforeCarouselUnloadEventBlockFix(c),
                  c.removeClass("owl-carousel").data("owl.carousel").destroy(),
                  t
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"))
                : h ||
                  ((h = !0),
                  theme.beforeCarouselLoadEventBlockFix(c),
                  c.find(".thumbnail").show(),
                  t.find(".hidden-thumbnails").children().appendTo(c),
                  c
                    .addClass("owl-carousel")
                    .on("initialized.owl.carousel", function () {
                      $(".lazyload--manual", this)
                        .removeClass("lazyload--manual")
                        .addClass("lazyload");
                    })
                    .owlCarousel({
                      items: d,
                      dots: !1,
                      margin: 7,
                      rtl: !!document.querySelector("html[dir=rtl]"),
                    }),
                  t
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"));
            };
          $(window).on("debouncedresize.productGallery", u),
            u(),
            $(e).data("assessCarouselCallback", u),
            $(".gallery", e).on(
              "click select selectFromSlick",
              ".thumbnails.owl-carousel .thumbnail",
              function (e) {
                e.preventDefault();
                var t = $(this).parent();
                if ("selectFromSlick" != e.type) {
                  var i = $(this).data("media-id"),
                    a = $(this)
                      .closest(".gallery")
                      .find(".slideshow.slick-slider");
                  if (a) {
                    var n = a.find('.slide[data-media-id="' + i + '"]').index();
                    a.slick("getSlick").currentSlide === n
                      ? $(this).trigger("selectFromSlick")
                      : a.slick("slickGoTo", n);
                  }
                } else {
                  $(this)
                    .addClass("selected")
                    .parent()
                    .siblings()
                    .find("a")
                    .removeClass("selected");
                  var o = t.parent().children(".active:first").index(),
                    s = o + d - 1,
                    r = t.index();
                  r < o
                    ? t.closest(".owl-carousel").trigger("to.owl.carousel", r)
                    : r > s &&
                      t
                        .closest(".owl-carousel")
                        .trigger("to.owl.carousel", Math.max(0, r - d + 1));
                }
              }
            ),
            $(".gallery", e).on(
              "click select selectFromSlick",
              " .thumbnails:not(.owl-carousel) .thumbnail",
              function (e) {
                if ((e.preventDefault(), "selectFromSlick" != e.type)) {
                  var t = 0,
                    i = $(this).data("media-id");
                  $(this)
                    .parent()
                    .children(":visible")
                    .each(function (e) {
                      if (((t = e), $(this).data("media-id") == i)) return !1;
                    });
                  var a = $(this).closest(".gallery").find(".slideshow");
                  a.slick("getSlick").currentSlide === t
                    ? $(this).trigger("selectFromSlick")
                    : a.slick("slickGoTo", t);
                } else
                  $(this)
                    .addClass("selected")
                    .siblings(".selected")
                    .removeClass("selected");
              }
            );
        }
      }
    }),
    (theme.destroyProductGallery = function (e) {
      $(window).off(".productGallery");
      var t = $(".gallery", e).off("click select selectFromSlick");
      theme.ProductMedia.destroy(t),
        $(".slick-slider", e)
          .slick("unslick")
          .off("init beforeChange afterChange"),
        $(".owl-carousel", e).each(function () {
          theme.beforeCarouselUnloadEventBlockFix(this),
            $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.ProductMedia = new (function () {
      var e = this;
      (e._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            e._setupShopifyXr.bind(this)
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse($(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (t, i) {
          var i = i || {},
            a = t;
          $(t)
            .find(".product-media--video")
            .each(function (e) {
              var t = this.querySelector(".product-media__poster");
              $(".product-media__video-play-btn", t).on("click", function () {
                $(this).closest(".product-media--video").data("player").play();
              });
              var i = { container: this, poster: t };
              i.play = function () {
                theme.pauseAllMedia(),
                  this.poster.classList.add("product-media__poster--hide"),
                  $(this).closest(".slick-slider").slick("setPosition"),
                  this.container
                    .querySelectorAll(".js-youtube")
                    .forEach((e) => {
                      e.contentWindow.postMessage(
                        '{"event":"command","func":"playVideo","args":""}',
                        "*"
                      );
                    }),
                  this.container.querySelectorAll(".js-vimeo").forEach((e) => {
                    e.contentWindow.postMessage('{"method":"play"}', "*");
                  }),
                  this.container
                    .querySelectorAll("video")
                    .forEach((e) => e.play());
              }.bind(i);
              var a = this.querySelector(".product-media__video-template");
              a &&
                (this.insertAdjacentHTML("beforeend", a.innerHTML),
                this.removeChild(a),
                (this.style.paddingBottom =
                  100 /
                    this.querySelector("video, iframe").getAttribute(
                      "aspect-ratio"
                    ) +
                  "%")),
                $(this)
                  .data("player", i)
                  .addClass("product-media--video-loaded");
            }),
            $(t).on(
              "mediaVisible",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(window).width() >= 768 && $(this).data("player").play(),
                  $(this).hasClass("product-media--model") &&
                    $(".view-in-space", a).attr(
                      "data-shopify-model3d-id",
                      $(this).data("model-id")
                    );
              }
            ),
            i.onVideoVisible &&
              $(t).on(
                "mediaVisible",
                ".product-media--video-loaded",
                i.onVideoVisible
              ),
            $("model-viewer", t).each(function () {
              i.onModelViewerPlay &&
                $(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  i.onModelViewerPlay
                ),
                i.onModelViewerPause &&
                  $(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    i.onModelViewerPause
                  );
            }),
            $(t).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded)",
              function (e) {
                var t = $(this).find("model-viewer")[0],
                  a = "mediaVisibleInitial" != e.type;
                theme.loadStyleOnce(
                  "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
                ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        $(this).data("player", new Shopify.ModelViewerUI(t)),
                          $(this).addClass("product-media--model-loaded"),
                          i.onModelViewerInit && i.onModelViewerInit(t),
                          a && $(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              }
            ),
            $(".model-json", t).length &&
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: e._setupShopifyXr.bind($(".model-json", t)),
                },
              ]),
            $(document).on("shopify_xr_launch", function () {
              theme.pauseAllMedia({ videos: !0 });
            }),
            setTimeout(
              function () {
                $(".product-slideshow.slick-slider .product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial"),
                  $(
                    ".product-slideshow:not(.slick-slider) .product-media--model",
                    this
                  ).trigger("mediaVisibleInitial");
              }.bind(t),
              50
            );
        }),
        (this.destroy = function (e) {
          $(document).off("shopify_xr_launch"),
            $(e).off("mediaVisible mediaVisibleInitial"),
            $(".product-media--model-loaded", e).each(function () {
              $(this).data("player").destroy();
            }),
            $(".product-media--video video", e).off("playing pause ended"),
            $("model-viewer", e).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
            );
        });
    })()),
    (theme.productGallerySlideshowTabFix = function (e, t) {
      $(e[t])
        .find(
          "a, input, button, select, iframe, video, model-viewer, [tabindex]"
        )
        .each(function () {
          void 0 !== $(this).data("theme-slideshow-original-tabindex")
            ? !1 === $(this).data("theme-slideshow-original-tabindex")
              ? $(this).removeAttr("tabindex")
              : $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex")
                )
            : $(this).removeAttr("tabindex");
        }),
        $(e)
          .not(e[t])
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            void 0 === $(this).data("theme-slideshow-original-tabindex") &&
              ($(this).data(
                "theme-slideshow-original-tabindex",
                void 0 !== $(this).attr("tabindex") && $(this).attr("tabindex")
              ),
              $(this).attr("tabindex", "-1"));
          });
    }),
    (theme.productData = {}),
    (theme.OptionManager = new (function () {
      var e = this;
      (e._getVariantOptionElement = function (e, t) {
        return t.find(
          'select[name="id"] option[value="' + (e ? e.id : "") + '"]'
        );
      }),
        (e.selectors = {
          container: ".product-detail",
          gallery: ".gallery",
          priceArea: ".price-area",
          variantIdInputs: '[name="id"]',
          purchaseForm: ".product-purchase-form",
          primaryVariantIdInput: '.product-purchase-form [name="id"]',
          submitButton: '.product-purchase-form button[type="submit"]',
          multiOption: ".option-selectors",
          customOption: ".custom-option",
          installmentsFormSuffix: "-installments",
        }),
        (e.strings = {
          buttonDefault: theme.strings.products_product_add_to_cart,
          buttonNoStock: theme.strings.products_variant_no_stock,
          buttonNoVariant: theme.strings.products_variant_non_existent,
        }),
        (e.getProductData = function (e) {
          var t = e.data("product-id"),
            i = null;
          return (
            theme.productData[t] ||
              (theme.productData[t] = JSON.parse(
                document.getElementById("ProductJson-" + t).innerHTML
              )),
            (i = theme.productData[t]) ||
              console.log(
                "Product data missing (id: " + e.data("product-id") + ")"
              ),
            i
          );
        }),
        (e.getVariantFromId = function (e, t) {
          for (
            var i = this.getProductData(e).variants, a = 0;
            a < i.length;
            a++
          )
            if (i[a].id == t) return i[a];
          return { available: !1 };
        }),
        (e.getCurrentVariantData = function (t) {
          return e.getVariantFromId(
            t,
            t.find(e.selectors.primaryVariantIdInput).val()
          );
        }),
        (e.getBaseUnit = function (e) {
          return 1 === e.unit_price_measurement.reference_value
            ? e.unit_price_measurement.reference_unit
            : e.unit_price_measurement.reference_value +
                e.unit_price_measurement.reference_unit;
        }),
        (e.addVariantUrlToHistory = function (e) {
          if (e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        }),
        (e.updateSku = function (e, t) {
          t.find(".sku .sku__value").html(e ? e.sku : ""),
            t.find(".sku").toggleClass("sku--no-sku", !e || !e.sku);
        }),
        (e.updateBarcode = function (e, t) {
          t.find(".barcode .barcode__value").html(e ? e.barcode : ""),
            t
              .find(".barcode")
              .toggleClass("barcode--no-barcode", !e || !e.barcode);
        }),
        (e.updateTransferNotice = function (t, i) {
          var a = e._getVariantOptionElement(t, i).data("inventory-transfer");
          a
            ? i
                .find(".product-inventory-transfer")
                .removeClass("product-inventory-transfer--none")
                .html(a)
            : i
                .find(".product-inventory-transfer")
                .addClass("product-inventory-transfer--none")
                .empty();
        }),
        (e.updateVariantDeterminedVisibilityAreas = function (e, t) {
          t.find(".variant-visibility-area").each(function () {
            $(this).children(":not(script)").remove(),
              e
                ? $(this).append(
                    $(this)
                      .children('script[data-variant-id="' + e.id + '"]')
                      .html()
                  )
                : $(this).append(
                    $(this).children('script[data-variant-id=""]').html()
                  );
          });
        }),
        (e.updateBackorder = function (t, i) {
          var a = i.find(".backorder");
          if (a.length) {
            if (t && t.available) {
              if (
                t.inventory_management &&
                "out" == e._getVariantOptionElement(t, i).data("stock")
              ) {
                var n = e.getProductData(a.closest(".product-form"));
                a
                  .find(".backorder__variant")
                  .text(
                    n.title +
                      (t.title.indexOf("Default") >= 0 ? "" : " - " + t.title)
                  ),
                  a.show();
              } else a.hide();
            } else a.hide();
          }
        }),
        (e._updateButtonText = function (t, i, a) {
          t.each(function () {
            var t;
            !1 !== (t = e.strings["button" + i]) &&
              ($(this).is("input") ? $(this).val(t) : $(this).html(t));
          });
        }),
        (e.updateButtons = function (t, i) {
          var a = i.find(e.selectors.submitButton);
          t
            ? (a.removeAttr("disabled").removeClass("button--sold-out"),
              !0 == t.available
                ? e._updateButtonText(a, "Default", t)
                : (a.addClass("button--sold-out"),
                  e._updateButtonText(a, "NoStock", t)))
            : e.getProductData(a.closest(".product-form")).available
            ? theme.getEmptyOptionSelectors(i).length
              ? (a.removeAttr("disabled"), e._updateButtonText(a, "Default", t))
              : (a.attr("disabled", "disabled"),
                e._updateButtonText(a, "NoVariant", t))
            : (a.addClass("button--sold-out"),
              e._updateButtonText(a, "NoStock", t));
        }),
        (e.updateContainerStatusClasses = function (t, i) {
          i.toggleClass("variant-status--not-selected", !t),
            i.toggleClass("variant-status--unavailable", t && !t.available),
            i.toggleClass(
              "variant-status--backorder",
              t &&
                t.available &&
                t.inventory_management &&
                "out" == e._getVariantOptionElement(t, i).data("stock")
            ),
            i.toggleClass(
              "variant-status--on-sale",
              t && t.available && t.compare_at_price > t.price
            );
        }),
        (e.initProductOptions = function (t) {
          if (!t.hasClass("theme-init")) {
            var i = e.getProductData(t);
            t.addClass("theme-init"),
              t
                .find(e.selectors.multiOption)
                .on("change.themeProductOptions", function () {
                  var a = [];
                  $(this)
                    .find(".option-selector")
                    .each(function () {
                      "listed" === $(this).data("selector-type")
                        ? a.push($(this).find(".js-option:checked").val())
                        : a.push(
                            $(this)
                              .find('.js-option[aria-selected="true"]')
                              .data("value")
                          );
                    });
                  for (var n = !1, o = 0; o < i.variants.length; o++) {
                    for (var s = i.variants[o], r = 0, l = 0; l < a.length; l++)
                      s.options[l] == a[l] && r++;
                    if (r == a.length) {
                      n = s;
                      break;
                    }
                  }
                  t.find(e.selectors.variantIdInputs).val(n.id),
                    t.find(e.selectors.variantIdInputs).each(function () {
                      this.dispatchEvent(
                        new CustomEvent("change", {
                          bubbles: !0,
                          cancelable: !1,
                          detail: { variant: n, selectedOptions: a },
                        })
                      );
                    });
                }),
              t
                .find(e.selectors.customOption)
                .each(function () {
                  var i = $(this).find("input:first, textarea, select");
                  $('<input type="hidden">')
                    .attr({ name: i.attr("name"), value: i.val() })
                    .appendTo(t.find(e.selectors.purchaseForm));
                })
                .on("change.themeProductOptions", function () {
                  var i = $(this).find('input[type="radio"]'),
                    a = $(this).find('input[type="checkbox"]');
                  if (i.length)
                    t.find(e.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === i[0].name;
                      })
                      .val(i.filter(":checked").val())
                      .trigger("change");
                  else if (a.length) {
                    var n = null;
                    (n = a.is(":checked")
                      ? a.val()
                      : a.siblings('[type="hidden"]').val()),
                      t
                        .find(e.selectors.purchaseForm + " input")
                        .filter(function () {
                          return this.name === a[0].name;
                        })
                        .val(n)
                        .trigger("change");
                  } else {
                    var o = $(this).find("select, input, textarea");
                    t.find(e.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === o.attr("name");
                      })
                      .val(o.val())
                      .trigger("change");
                  }
                }),
              t.find(e.selectors.primaryVariantIdInput).each(function () {
                $(this).on(
                  "change.themeProductOptions firstrun.themeProductOptions",
                  function (a) {
                    if (!$(this).is("input[type=radio]:not(:checked)")) {
                      var n = a.detail ? a.detail.variant : null;
                      if (!n && !1 !== n)
                        for (var o = 0; o < i.variants.length; o++)
                          i.variants[o].id == $(this).val() &&
                            (n = i.variants[o]);
                      var s = $(this).closest(e.selectors.container),
                        r = s
                          .find(e.selectors.submitButton)
                          .filter("[data-add-to-cart-text]");
                      if (
                        (r.length &&
                          (e.strings.buttonDefault =
                            r.data("add-to-cart-text")),
                        e.updateButtons(n, s),
                        $(window).trigger("cc-variant-updated", {
                          variant: n,
                          product: i,
                        }),
                        n && n.featured_media)
                      )
                        s.find(e.selectors.gallery).trigger(
                          "variantImageSelected",
                          [n, "firstrun" === a.type]
                        );
                      else if (a.detail && a.detail.selectedOptions) {
                        var l = a.detail.selectedOptions.filter(
                          (e) => e && e.length > 0
                        ).length;
                        if (l > 0)
                          for (var o = 0; o < i.variants.length; o++) {
                            for (
                              var c = i.variants[o], d = 0, h = 0;
                              h < a.detail.selectedOptions.length;
                              h++
                            )
                              c.options[h] == a.detail.selectedOptions[h] &&
                                d++;
                            if (d == l && c.featured_media) {
                              s.find(e.selectors.gallery).trigger(
                                "variantImageSelected",
                                [c, "firstrun" === a.type]
                              );
                              break;
                            }
                          }
                      }
                      e.updateBarcode(n, s),
                        e.updateSku(n, s),
                        e.updateTransferNotice(n, s),
                        e.updateVariantDeterminedVisibilityAreas(n, s),
                        e.updateBackorder(n, s),
                        e.updateContainerStatusClasses(n, s),
                        t.data("enable-history-state") &&
                          "change" == a.type &&
                          e.addVariantUrlToHistory(n),
                        t.trigger("variantChanged", [n, i]);
                    }
                  }
                ),
                  $(this).trigger("firstrun");
              }),
              console.log(t)
              theme.applyAjaxToProductForm(t);
            var a = new URLSearchParams(location.search),
              n = function e(i) {
                t.find(".option-selector")
                  .filter(function () {
                    return (
                      this.querySelector(".label").firstChild.textContent === i
                    );
                  })
                  .each(function () {
                    var e = a.get(i);
                    "dropdown" == this.dataset.selectorType
                      ? this.querySelector(".cc-select").dispatchEvent(
                          new CustomEvent("selectOption", {
                            detail: { value: e },
                          })
                        )
                      : this.querySelectorAll(".opt-label__text").forEach(
                          (t) => {
                            if (t.innerText == e) {
                              var i = document.getElementById(
                                t.parentElement.getAttribute("for")
                              );
                              i &&
                                ((i.checked = !0),
                                i.dispatchEvent(
                                  new CustomEvent("change", {
                                    bubbles: !0,
                                    cancelable: !1,
                                  })
                                ));
                            }
                          }
                        );
                  });
              };
            for (var o of a.keys()) n(o);
          }
        }),
        (e.unloadProductOptions = function (t) {
          t.removeClass("theme-init").each(function () {
            $(this).trigger("unloading").off(".themeProductOptions"),
              $(this).find(e.selectors.multiOption).off(".themeProductOptions"),
              $(this)
                .find(e.selectors.customOption)
                .off(".themeProductOptions"),
              theme.removeAjaxFromProductForm(t);
          });
        });
    })()),
    (theme.loadQuickbuy = function () {
      function e(e, t) {
        e.length > 0 &&
          (e.removeClass("expanded"),
          e
            .find(".quickbuy-container")
            .stop()
            .animate({ height: 0 }, t, function () {
              $(this).find(".inner").empty();
            }),
          e.stop().each(function () {
            $(this).animate({ paddingBottom: 0 }, t);
          }));
      }
      function t(e) {
        $(e)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach((t) => {
                $(document).trigger("cc:component:load", [t, e]);
              });
          }),
          $(document).trigger("cc:component:load", [
            "custom-select",
            ".quickbuy-container",
          ]);
      }
      function i(e) {
        $(e).find(".cc-accordion").off(".qbLoadComponents"),
          $(e)
            .closest("[data-components]")
            .each(function () {
              $(this)
                .data("components")
                .split(",")
                .forEach((t) => {
                  $(document).trigger("cc:component:unload", [t, e]);
                });
            });
      }
      var a = -1;
      function n(e) {
        clearTimeout(a),
          (a = setTimeout(() => {
            var t = e.closest(".quickbuy-container"),
              i = t.closest(".product-block");
            if (i) {
              if (i.classList.contains("expanded")) {
                var a = $(e).outerHeight(),
                  n =
                    [...i.parentNode.children].filter(
                      (e) => e !== i && e.classList.contains("expanded")
                    ).length > 0
                      ? 0
                      : s;
                $(i)
                  .stop()
                  .animate({ paddingBottom: a + 20 }, n),
                  $(t).stop().animate({ height: a }, n);
              }
            } else
              e.childElementCount > 0 &&
                $(t)
                  .stop()
                  .animate({ height: $(e).outerHeight() }, s);
          }, 100));
      }
      var o = null;
      o =
        "ResizeObserver" in window
          ? new ResizeObserver((e) => {
              for (var t of e) t.contentBoxSize && n(t.target);
            })
          : { disconnect() {}, observer() {} };
      var s = 500;
      function r() {
        $(".collection-listing").each(function () {
          var e = $(this).find(".product-block");
          if (e.length <= 1) return !0;
          var t = 0,
            i = 0,
            a = Math.min(e.first().outerHeight(), $(e[1]).outerHeight()),
            n = e.first().offset().top;
          e.each(function (e) {
            var o = $(this).offset().top;
            0 == e ? (i = o) : o > i && (t++, (i = o)),
              $(this).data({ offsetTop: n + t * a });
          });
        });
      }
      $(document).on(
        "click",
        ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle",
        function () {
          var a = $(window).width(),
            n = $(this).attr("href");
          if (a > 767) {
            theme.currentQuickbuyRequest &&
              theme.currentQuickbuyRequest.abort();
            var l = $(this).closest(".product-block"),
              c = null,
              d = null,
              h = $(this).closest(".collection-slider"),
              u = null;
            if (h.length > 0) {
              if (
                0 ===
                (u = h.closest(".collection-slider-row")).find(
                  ".quickbuy-container"
                ).length
              )
                return;
              d = u.find(".quickbuy-container");
            } else d = l.find(".quickbuy-container");
            if (
              ((c = d.find(".inner")),
              l.toggleClass("expanded").hasClass("expanded"))
            ) {
              h.length > 0
                ? 0 ===
                  h
                    .find(".product-block.expanded")
                    .not(l)
                    .removeClass("expanded").length
                  ? d.height(0)
                  : ($(".product-form", d).trigger("unload-product-form"),
                    $(".gallery", d).off(this.namespace),
                    $(".slideshow", d).slick("unslick"),
                    i(d))
                : l.siblings(".expanded").each(function () {
                    e($(this), 0),
                      $(".product-form", this).trigger("unload-product-form"),
                      theme.destroyProductGallery(this),
                      i(this);
                  }),
                o.disconnect(),
                o.observe(c[0]),
                c.html('<div class="loading-spinner"></div>');
              var p = $(this).attr("href");
              (theme.currentQuickbuyRequest = $.get(p, function (e) {
                var i = $("<div>" + e + "</div>").find(".quickbuy-content");
                i.find(".more").attr("href", n),
                  i.find(".detail .title").wrapInner($("<a>").attr("href", n)),
                  i
                    .find(".show-gallery")
                    .removeClass("show-gallery")
                    .attr("href", n),
                  i.find(".not-in-quickbuy").remove(),
                  i.find(".only-in-quickbuy").removeClass("only-in-quickbuy"),
                  i
                    .find(".sticky-content-container")
                    .removeClass("sticky-content-container"),
                  i.find(".store-availability-container").remove(),
                  i
                    .find('[data-enable-history-state="true"]')
                    .attr("data-enable-history-state", "false"),
                  i.find(".gallery .thumbnails").removeClass("mobile-only"),
                  [
                    "gallery--layout-carousel-beside",
                    "gallery--layout-columns-1",
                    "gallery--layout-columns-2",
                    "gallery--layout-collage-1",
                    "gallery--layout-collage-2",
                  ].forEach((e) => {
                    i.find("." + e)
                      .removeClass(e)
                      .addClass("gallery--layout-carousel-under");
                  }),
                  c.html(i),
                  theme.initProductGallery(d),
                  d.find(".product-form").trigger("load-product-form"),
                  t(d),
                  theme.initAnimateOnScroll();
              }).always(function () {
                theme.currentQuickbuyRequest = !1;
              })),
                d.find(".close-detail").removeAttr("tabindex");
              var f = "qb",
                m = -120;
              if (
                ("sticky" == $(".section-header").css("position") &&
                  (m -= $(".section-header").height()),
                "qb" == f)
              )
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: d.offset().top + m },
                  500
                );
              else if (h.length > 0)
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: l.offset().top },
                  500
                );
              else {
                r();
                var g =
                  void 0 !== l.data("offsetTop")
                    ? l.data("offsetTop")
                    : l.offset().top;
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: g + m },
                  500
                );
              }
            } else {
              i(d),
                h.length > 0
                  ? d.stop().animate({ height: 0 }, s, function () {
                      c.empty();
                    })
                  : e(l, s);
              var v = -140;
              $("html:not(:animated),body:not(:animated)").animate(
                { scrollTop: l.offset().top + v },
                500
              ),
                d.find(".close-detail").attr("tabindex", "-1");
            }
            return !1;
          }
        }
      ),
        $(document).on(
          "click",
          ".quickbuy-container .close-detail",
          function () {
            var e = $(this).closest(".collection-slider-row");
            return (
              e.length
                ? e
                    .find(".product-block.expanded .quickbuy-toggle:first")
                    .trigger("click")
                : $(this)
                    .closest(".product-block")
                    .find(".quickbuy-toggle:first")
                    .trigger("click"),
              !1
            );
          }
        );
    }),
    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var t = $(this).parent();
        if (t.hasClass("twitter")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 575,
            n = 450,
            o = ($(window).width() - a) / 2,
            s = ($(window).height() - n) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              n +
              ",top=" +
              s +
              ",left=" +
              o;
          window.open(i, "Twitter", r);
        } else if (t.hasClass("facebook")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 626,
            n = 256,
            o = ($(window).width() - a) / 2,
            s = ($(window).height() - n) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              n +
              ",top=" +
              s +
              ",left=" +
              o;
          window.open(i, "Facebook", r);
        } else if (t.hasClass("pinterest")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 700,
            n = 550,
            o = ($(window).width() - a) / 2,
            s = ($(window).height() - n) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              n +
              ",top=" +
              s +
              ",left=" +
              o;
          window.open(i, "Pinterest", r);
        } else if (t.hasClass("google")) {
          e.preventDefault();
          var i = $(this).attr("href"),
            a = 550,
            n = 450,
            o = ($(window).width() - a) / 2,
            s = ($(window).height() - n) / 2,
            r =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              a +
              ",height=" +
              n +
              ",top=" +
              s +
              ",left=" +
              o;
          window.open(i, "Google+", r);
        }
      });
    });
  var TermsAgreement = class extends HTMLElement {
    connectedCallback() {
      this.delegatedEvent = theme.addDelegateEventListener(
        document,
        "click",
        '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
        this.handleFormSubmittingEvent.bind(this)
      );
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.delegatedEvent);
    }
    handleFormSubmittingEvent(e) {
      this.querySelector("input:checked") ||
        (e.preventDefault(),
        theme.showQuickPopup(
          theme.strings.cart_terms_confirmation,
          $(e.target)
        ));
    }
  };
  window.customElements.define("terms-agreement", TermsAgreement),
    (theme.AnnouncementBarSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.container = e),
          (this.namespace = theme.namespaceFromSection(e)),
          $(".disclosure", e).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          (this.announcements = e.querySelectorAll(".announcement")),
          this.announcements.length > 1 &&
            ((this.currentAnnouncement = 0),
            e
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusin",
                this.functions.pauseAnnouncements.bind(this)
              ),
            e
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusout",
                this.functions.playAnnouncements.bind(this)
              ),
            e
              .querySelector(".announcement-button--previous")
              .addEventListener(
                "click",
                this.functions.previousAnnouncement.bind(this)
              ),
            e
              .querySelector(".announcement-button--next")
              .addEventListener(
                "click",
                this.functions.nextAnnouncement.bind(this)
              ),
            (this.observer = new IntersectionObserver(
              this.functions.handleIntersect.bind(this)
            )),
            this.observer.observe(this.container));
      }),
        (this.functions = {
          handleIntersect: function e(t) {
            t.forEach((e) => {
              e.target == this.container &&
                (e.isIntersecting
                  ? this.functions.playAnnouncements.call(this)
                  : this.functions.pauseAnnouncements.call(this));
            });
          },
          playAnnouncements: function e() {
            this.announcementInterval = setInterval(() => {
              this.functions.setCurrentAnnouncement.call(
                this,
                this.currentAnnouncement + 1
              );
            }, 5e3);
          },
          pauseAnnouncements: function e() {
            this.announcementInterval &&
              clearInterval(this.announcementInterval);
          },
          setCurrentAnnouncement: function e(t) {
            (this.currentAnnouncement = t % this.announcements.length),
              this.announcements.forEach((e, t) => {
                t !== this.currentAnnouncement
                  ? e.classList.add("announcement--inactive")
                  : e.classList.remove("announcement--inactive");
              });
          },
          previousAnnouncement: function e() {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement - 1
            );
          },
          nextAnnouncement: function e() {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement + 1
            );
          },
        }),
        (this.onSectionUnload = function (e) {
          clearInterval(this.announcementInterval),
            $(".disclosure", e).each(function () {
              $(this).data("disclosure").unload();
            }),
            this.observer && this.observer.disconnect(),
            $(window).off(this.namespace);
        }),
        (this.onBlockSelect = function (e) {
          var t = Array.prototype.indexOf.call(e.parentElement.children, e);
          this.functions.pauseAnnouncements.call(this),
            this.functions.setCurrentAnnouncement.call(this, t);
        }),
        (this.onBlockDeselect = function (e) {
          this.functions.playAnnouncements.call(this);
        });
    })()),
    (theme.BlogTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          this.$container.on(
            "click" + this.namespace,
            ".link-dropdown__button",
            theme.toggleLinkDropdownButton.bind(this)
          ),
          $(document).on("click" + this.namespace, function () {
            $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
          });
      }),
        (this.onSectionUnload = function (e) {
          this.$container.off(this.namespace), $(document).off(this.namespace);
        });
    })()),
    (theme.CartTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.$container = $(e)),
          $(e).on(
            "click.cartTemplateSection",
            "button[data-toggle-shipping]",
            function () {
              $("#shipping-calculator").toggle();
              var e = $(this).data("toggle-html");
              return (
                $(this).data("toggle-html", $(this).html()), $(this).html(e), !1
              );
            }
          );
      }),
        (this.onSectionUnload = function (e) {
          $(e).off(".cartTemplateSection");
        });
    })()),
    (theme.CartDrawerSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.container = e),
          (this.namespace = theme.namespaceFromSection(e)),
          (this.popup = new ccPopup($(".cc-popup", e), this.namespace)),
          (this.boundOpen = () => {
            this.popup.open();
          }),
          document.addEventListener("theme:open-cart-drawer", this.boundOpen),
          (this.boundClose = () => this.popup.close()),
          document.addEventListener("theme:close-cart-drawer", this.boundClose),
          e
            .querySelectorAll(".cc-popup-close")
            .forEach((e) => e.addEventListener("click", this.boundClose)),
          e
            .querySelector(".cc-popup-background")
            .addEventListener("click", this.boundClose);
      }),
        (this.onSectionSelect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:open-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            })
          );
        }),
        (this.onSectionDeselect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:close-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            })
          );
        }),
        (this.onSectionUnload = function (e) {
          document.removeEventListener(
            "theme:open-cart-drawer",
            this.boundOpen
          ),
            document.removeEventListener(
              "theme:close-cart-drawer",
              this.boundClose
            );
        });
    })()),
    (theme.CollectionTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.filterer = new theme.LoadFilterer(this)),
          $(window).on(
            "debouncedresize" + this.namespace,
            this.functions.truncateButtonSubcollections.bind(this)
          ),
          this.functions.truncateButtonSubcollections.call(this);
        var t = $(".subcollection-links--gallery .gallery", e);
        t.on("init", function () {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        }).slick({
          autoplay: !1,
          fade: !1,
          infinite: !1,
          swipeToSlide: !0,
          slidesToShow: Math.min(
            4,
            $(".subcollection-links--gallery .gallery__item", e).length
          ),
          slidesToScroll: 1,
          useTransform: !0,
          arrows: !0,
          dots: !1,
          prevArrow:
            '<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button>",
          nextArrow:
            '<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button>",
          rtl: !!document.querySelector("html[dir=rtl]"),
          responsive: [
            {
              breakpoint: 1e3,
              settings: {
                slidesToShow: Math.min(
                  3,
                  $(".subcollection-links--gallery .gallery__item", e).length
                ),
              },
            },
            {
              breakpoint: 768,
              settings:
                "hide" == t.data("mobile-item-count")
                  ? "unslick"
                  : { slidesToShow: t.data("mobile-item-count") },
            },
          ],
        });
      }),
        (this.onSectionUnload = function (e) {
          this.filterer.destroy(),
            $(".subcollection-links__expander", this.$container).off("click"),
            $(".slick-slider", e).slick("unslick").off("init"),
            $(window).off(this.namespace);
        }),
        (this.functions = {
          truncateButtonSubcollections: function e() {
            var t = $(".subcollection-links--buttons", this.$container);
            if ("flex" == t.css("display")) {
              var i = 4,
                a = t.find(".btn");
              a.length > i &&
                0 === t.find(".subcollection-links__expander").length &&
                (a.slice(i - 1).hide(),
                $(
                  '<a href="#" class="btn btn--tertiary subcollection-links__expander">'
                )
                  .text(
                    theme.strings.collections_general_see_all_subcollections
                  )
                  .appendTo(t)
                  .on("click", function (e) {
                    e.preventDefault(),
                      $(this).siblings().show(),
                      $(this).remove();
                  }));
            } else
              t.find(".subcollection-links__expander").length &&
                (t.find(".subcollection-links__expander").siblings().show(),
                t.find(".subcollection-links__expander").remove());
          },
        });
    })()),
    (theme.CustomRowSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.VideoManager.onSectionLoad(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.VideoManager.onSectionUnload(e);
        });
    })()),
    (theme.FeaturedCollectionSection = new (function () {
      (this.onSectionLoad = function (e) {
        0 === theme.loadCarousels(e).length &&
          theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e), theme.unloadCarousels(e);
        });
    })()),
    (theme.FeaturedCollectionsSection = new (function () {
      (this.onSectionLoad = function (e) {
        0 === theme.loadCarousels(e).length &&
          theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e), theme.unloadCarousels(e);
        });
    })()),
    (theme.FeaturedProductSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.initProductGallery(e),
          $(".product-form", e).trigger("load-product-form"),
          theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e),
            theme.destroyProductGallery(e),
            $(".product-form", e).trigger("unload-product-form"),
            $(".slideshow", e).slick("unslick");
        });
    })()),
    (theme.FooterSection = new (function () {
      (this.onSectionLoad = function (e) {
        $(".disclosure", e).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (e) {
          $(".disclosure", e).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.GallerySection = new (function () {
      (this.onSectionLoad = function (e) {
        var t = $(".gallery--mobile-carousel", e);
        if (t.length) {
          var i = function e() {
            var i = t.hasClass("slick-slider"),
              a = 768 > $(window).width();
            if (
              (a ||
                $(".lazyload--manual", t)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
              i && !a)
            ) {
              t.slick("unslick").off("init"),
                t
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var n = t.data("grid"),
                o = null;
              t.find(".gallery__item").each(function (e) {
                e % n == 0 && (o = $('<div class="gallery__row">').appendTo(t)),
                  $(this).appendTo(o);
              });
            } else
              !i &&
                a &&
                (t.find(".gallery__item").appendTo(t),
                t.find(".gallery__row").remove(),
                t
                  .on("init", function () {
                    $(".lazyload--manual", this)
                      .removeClass("lazyload--manual")
                      .addClass("lazyload");
                  })
                  .slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !0,
                    useTransform: !0,
                    arrows: !1,
                    dots: !0,
                    customPaging: function e(t, i) {
                      return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>';
                    },
                    rtl: !!document.querySelector("html[dir=rtl]"),
                  }));
          };
          i(), $(window).on("debouncedresize.themeSection" + e.id, i);
        }
        $(".overlay-text__title, .overlay-text__rte", e).each(function () {
          theme.avoidUnecessaryOrphans(this);
        });
      }),
        (this.onSectionUnload = function (e) {
          $(window).off(".themeSection" + e.id),
            $(".slick-slider", e).each(function () {
              $(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (e) {
          var t = $(e).data("slick-index");
          $(e)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", t);
            });
        });
    })()),
    (theme.HeaderSection = new (function () {
      (this.onSectionLoad = function (container) {
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".social-links",
          function (e) {
            return !1;
          }
        );
        var searchFocusOutTimeoutId = -1;
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".search-box",
          function (e) {
            "focusin" == e.type
              ? (clearTimeout(searchFocusOutTimeoutId),
                $(this).closest(".search-box").addClass("focus"))
              : (clearTimeout(searchFocusOutTimeoutId),
                (searchFocusOutTimeoutId = setTimeout(
                  function () {
                    $(this).closest(".search-box").removeClass("focus");
                  }.bind(this),
                  200
                )));
          }
        ),
          $(container).on(
            "click.headerSection",
            ".show-search-link, .main-search__close",
            function (e) {
              return (
                $("body").toggleClass("show-search").hasClass("show-search")
                  ? (setTimeout(function () {
                      $(".main-search__input:first").focus();
                    }, 500),
                    $(".main-search__suggestions .lazyload--manual")
                      .removeClass("lazyload--manual")
                      .addClass("lazyload"))
                  : $(".show-search-link:first").focus(),
                !1
              );
            }
          ),
          $(container).on(
            "keyup.headerSection",
            ".main-search__input",
            function (e) {
              27 == e.keyCode && $(".main-search__close").click();
            }
          );
        var $liveSearchContainer = $(
          '.main-search[data-live-search="true"]',
          container
        );
        if ($liveSearchContainer.length) {
          var searchTimeoutThrottle = 500,
            searchTimeoutID = -1,
            currReqObj = null,
            resultLimit = 8,
            showPrice = $liveSearchContainer.data("live-search-price"),
            showVendor = $liveSearchContainer.data("live-search-vendor"),
            includeMeta = $liveSearchContainer.data("live-search-meta");
          $liveSearchContainer.data("per-row-mob"),
            $(container).on(
              "keyup.headerSection change.headerSection",
              ".main-search__input",
              function () {
                var e = $(".main-search"),
                  t = e.find(".main-search__results"),
                  i = $(this).val();
                if (i.length > 2 && i != $(this).data("oldval")) {
                  $(this).data("oldval", i),
                    null != currReqObj && currReqObj.abort(),
                    clearTimeout(searchTimeoutID);
                  var a = $(this).closest("form"),
                    n =
                      a.attr("action") +
                      (a.attr("action").indexOf("?") > -1 ? "&" : "?") +
                      a.serialize();
                  e
                    .removeClass(
                      "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                    )
                    .addClass("main-search--loading"),
                    0 === $(".main-search__results-spinner").length &&
                      t.html(
                        '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'
                      ),
                    (searchTimeoutID = setTimeout(function () {
                      var o, s;
                      theme.Shopify.features.predictiveSearch
                        ? ((o = theme.routes.predictive_search_url),
                          (s = {
                            q: i,
                            section_id: "predictive-search",
                            resources: {
                              type: a.find('input[name="type"]').val(),
                              limit: resultLimit,
                              options: {
                                unavailable_products: "last",
                                fields: includeMeta
                                  ? "title,product_type,variants.title,vendor,tag,variants.sku"
                                  : "title,product_type,variants.title,vendor",
                              },
                            },
                          }))
                        : ((o = n), (s = { section_id: "main-search" })),
                        (currReqObj = $.ajax({
                          url: o,
                          data: s,
                          dataType: "html",
                          success: function i(a) {
                            var o = null;
                            (o = theme.Shopify.features.predictiveSearch
                              ? $(a).find(".product-list")
                              : $("<div>" + a + "</div>").find(
                                  '[data-section-type="search-template"] .product-list'
                                )),
                              (currReqObj = null),
                              theme.ProductBlockManager.unloadImages(t),
                              e.removeClass(
                                "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                              ),
                              t.empty();
                            var s = $(
                                '<div class="main-search__results__products collection-listing"><div></div></div>'
                              ),
                              r = $(
                                '<div class="main-search__results__pages">'
                              );
                            (s.children()[0].className = o[0].className),
                              o
                                .find(
                                  ".product-block:not(.collection-block):not(.page-block)"
                                )
                                .slice(0, resultLimit)
                                .addClass("main-search-result")
                                .each(function () {
                                  $(this).find(".btn.quickbuy-toggle").remove(),
                                    $(this)
                                      .find(".quickbuy-toggle")
                                      .removeClass("quickbuy-toggle"),
                                    showPrice ||
                                      $(this).find(".product-price").remove(),
                                    showVendor ||
                                      $(this).find(".vendor").remove();
                                })
                                .appendTo(s.children()),
                              o
                                .find(".product-block.page-block")
                                .each(function () {
                                  var e = $(
                                    '<a class="main-search-result main-search-result--page">'
                                  ).attr(
                                    "href",
                                    $(this).find("a:first").attr("href")
                                  );
                                  $('<div class="main-search-result__text">')
                                    .text(
                                      $(this).find(".page-block__title").text()
                                    )
                                    .appendTo(e),
                                    r.append(e);
                                }),
                              e.removeClass("main-search--loading");
                            var l =
                                s.find(".main-search-result:first").length > 0,
                              c =
                                r.find(".main-search-result:first").length > 0;
                            l || c
                              ? (e.addClass("main-search--has-results"),
                                e.toggleClass(
                                  "main-search--results-on-multiple-lines",
                                  s.find(".product-block").length > 4
                                ),
                                l &&
                                  (t.append(s),
                                  theme.ProductBlockManager.loadImages(s)),
                                c &&
                                  ($('<h6 class="main-search-result__heading">')
                                    .html(
                                      theme.strings.general_quick_search_pages
                                    )
                                    .prependTo(r),
                                  t.append(r)),
                                $(
                                  '<a class="main-search__results-all-link button altcolour">'
                                )
                                  .attr("href", n)
                                  .html(
                                    theme.strings.layout_live_search_see_all
                                  )
                                  .appendTo(t),
                                theme.initAnimateOnScroll())
                              : (e.addClass("main-search--no-results"),
                                $('<div class="main-search__empty-message">')
                                  .html(
                                    theme.strings
                                      .general_quick_search_no_results
                                  )
                                  .appendTo(t));
                          },
                          error: function e(t) {
                            console.log("Error fetching results");
                          },
                        }));
                    }, searchTimeoutThrottle));
                } else
                  $(this).val().length <= 2 &&
                    ($(this).data("oldval", i),
                    null != currReqObj && currReqObj.abort(),
                    clearTimeout(searchTimeoutID),
                    e.removeClass(
                      "main-search--has-results main-search--results-on-multiple-lines main-search--loading"
                    ),
                    t.empty());
              }
            );
        }
        theme.Navigation.init({
          nav: $(".navigation--main", container),
          mobileNavHtml: $(
            ".mobile-navigation-drawer-template",
            container
          ).html(),
          proxyTier1Nav: $(".navigation--left", container),
        }),
          theme.inlineNavigationCheck
            ? (theme.inlineNavigationCheck(),
              $(window).on(
                "debouncedresize.headerSection",
                theme.inlineNavigationCheck
              ))
            : document.querySelector("#InlineNavigationCheckScript") &&
              eval(
                document.querySelector("#InlineNavigationCheckScript").innerHTML
              ),
          (this.section = document.querySelector(".section-header")),
          (this.transparentPageheader = document.querySelector(
            ".pageheader--transparent-permitted"
          )),
          this.functions.setTransparency.call(this),
          this.functions.setSticky.call(this),
          this.functions.setHeaderHeightProperty.call(this),
          $(window).on(
            "scroll.headerSection",
            this.functions.afterScroll.bind(this)
          ),
          $(window).on(
            "debouncedresize.headerSection",
            this.functions.afterResize.bind(this)
          ),
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          $(".mobile-navigation-drawer .disclosure").each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          "drawer" == theme.settings.cart_type &&
            document.querySelector(".cart-drawer") &&
            $(container).on("click.headerSection", ".cart-link", (e) => {
              e.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
            }),
          $(document).on("theme:cartchanged.headerSection", function () {
            $.getJSON(location.origin + "?sections=header", function (e) {
              for (
                var t = ["#pageheader .logo-area__right__inner"], i = 0;
                i < t.length;
                i++
              ) {
                var a = $("<div>" + e.header + "</div>")
                  .find(t[i])
                  .first();
                $(t[i]).html(a.html());
              }
            });
          }),
          Shopify.designMode &&
            $("body").hasClass("reveal-mobile-nav") &&
            theme.openMobileNav();
      }),
        (this.onSectionUnload = function (e) {
          $(e).off(".headerSection"),
            $(document).off(".headerSection"),
            $(window).off(".headerSection"),
            $(".disclosure", e).each(function () {
              $(this).data("disclosure").unload();
            }),
            $(".mobile-navigation-drawer .disclosure").each(function () {
              $(this).data("disclosure").unload();
            }),
            theme.Navigation.destroy(
              $(".navigation", e),
              $(".navigation--left", e)
            );
        }),
        (this.functions = {
          afterScroll: function e() {
            this.functions.setTransparency.call(this);
          },
          afterResize: function e() {
            this.functions.setSticky.call(this),
              this.functions.setHeaderHeightProperty.call(this);
          },
          setTransparency: function e() {
            if (this.transparentPageheader) {
              var t = document.querySelector(".section-announcement-bar"),
                i = t ? t.offsetTop + t.clientHeight : 0;
              !this.isSticky || window.scrollY <= i
                ? this.transparentPageheader.classList.add(
                    "pageheader--transparent"
                  )
                : this.transparentPageheader.classList.remove(
                    "pageheader--transparent"
                  );
            }
          },
          setSticky: function e() {
            this.isSticky =
              "sticky" === getComputedStyle(this.section).position ||
              "-webkit-sticky" === getComputedStyle(this.section).position;
          },
          setHeaderHeightProperty: function e() {
            var t = 0,
              i = 0;
            this.section &&
              ((t = Math.ceil(this.section.clientHeight)),
              this.isSticky && (i = t)),
              document.documentElement.style.setProperty(
                "--theme-header-height",
                t + "px"
              ),
              document.documentElement.style.setProperty(
                "--theme-sticky-header-height",
                i + "px"
              );
          },
        });
    })()),
    (theme.ImageWithTextOverlaySection = new (function () {
      var e = this;
      (e.checkForHeaderHeightSubtraction = function () {
        $(
          ".section-image-with-text-overlay .height--full-minus-header-height"
        ).each(function () {
          var e = $(window).height();
          document.querySelector(".pageheader--transparent-permitted") &&
          !this.closest(".shopify-section").previousElementSibling
            ? document
                .querySelectorAll(
                  ".section-store-messages, .section-announcement-bar"
                )
                .forEach((t) => {
                  e -= t.clientHeight;
                })
            : (e -= document.querySelector(".section-header").clientHeight),
            $(".rimage-outer-wrapper, .placeholder-image", this).height(e);
        });
      }),
        (this.onSectionLoad = function (t) {
          $(".height--full", t).each(function () {
            0 == $(this).closest(".section-image-with-text-overlay").index() &&
              ($(this).addClass("height--full-minus-header-height"),
              e.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.imageWithTextOverlaySection")
                .on(
                  "debouncedresize.imageWithTextOverlaySection",
                  e.checkForHeaderHeightSubtraction
                ));
          }),
            $(".overlay-text__title, .overlay-text__rte", t).each(function () {
              theme.avoidUnecessaryOrphans(this);
            });
        }),
        (this.onSectionUnload = function (e) {
          $(window).off(".imageWithTextOverlaySection");
        });
    })()),
    (theme.ListCollectionsTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        theme.ProductBlockManager.loadImages(e);
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e);
        });
    })()),
    (theme.ProductTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        $("[data-store-availability-container]", e).length &&
          (this.storeAvailability = new theme.StoreAvailability(
            $("[data-store-availability-container]", e)[0]
          )),
          theme.initProductGallery(e),
          $(".product-form", e).trigger("load-product-form"),
          theme.ProductBlockManager.loadImages(e),
          $(".theme-product-reviews", e).on("click", "a", function () {
            return (
              $("html,body").animate(
                { scrollTop: $($(this).attr("href")).offset().top },
                1e3
              ),
              !1
            );
          });

          document.addEventListener("recommendations:loaded", () => {
            $(".product-recommendations .product-form").trigger("load-product-form")
          })
      }),
        (this.onSectionUnload = function (e) {
          theme.ProductBlockManager.unloadImages(e),
            theme.destroyProductGallery(e),
            $(".product-form", e).trigger("unload-product-form"),
            $(".theme-product-reviews", e).off("click"),
            this.storeAvailability && this.storeAvailability.onSectionUnload();
        });
    })()),
    (theme.ScrollingBannerSection = new (function () {
      this.onSectionLoad = function (e) {
        document.fonts.ready.then(() =>
          e.querySelector(".marquee").classList.add("marquee--animate")
        ),
          e.querySelectorAll(".lazyload").forEach((e) => {
            lazySizes.loader.unveil(e);
          });
      };
    })()),
    (theme.SearchTemplateSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$container = $(e)),
          (this.filterer = new theme.LoadFilterer(this));
      }),
        (this.onSectionUnload = function () {
          this.filterer.destroy();
        });
    })()),
    (theme.SlideshowSection = new (function () {
      var e = this;
      (e.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(
          function () {
            var e = $(window).height();
            document.querySelector(".pageheader--transparent-permitted") &&
            !this.closest(".shopify-section").previousElementSibling
              ? document
                  .querySelectorAll(
                    ".section-store-messages, .section-announcement-bar"
                  )
                  .forEach((t) => {
                    e -= t.clientHeight;
                  })
              : (e -= document.querySelector(".section-header").clientHeight),
              $(".rimage-outer-wrapper, .placeholder-image", this).height(e);
          }
        );
      }),
        (this.onSectionLoad = function (t) {
          $(".slideshow", t).each(function () {
            var t = "instant" === $(this).data("transition") ? 0 : 800,
              i = 1e3 * $(this).data("autoplay-speed");
            $(this).find(".height--full").length &&
              0 == $(this).closest(".section-slideshow").index() &&
              ($(this).addClass("height--full-minus-header-height"),
              e.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.slideshowSection")
                .on(
                  "debouncedresize.slideshowSection",
                  e.checkForHeaderHeightSubtraction
                )),
              $(this)
                .on("init", function () {
                  $(".lazyload--manual", this)
                    .removeClass("lazyload--manual")
                    .addClass("lazyload");
                })
                .slick({
                  autoplay: $(this).data("autoplay"),
                  fade: "slide" !== $(this).data("transition"),
                  speed: t,
                  autoplaySpeed: i,
                  arrows: "arrows" === $(this).data("navigation"),
                  dots: "dots" === $(this).data("navigation"),
                  pauseOnHover: !1,
                  infinite: !0,
                  useTransform: !0,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' +
                    theme.strings.previous +
                    '">' +
                    theme.icons.chevronLeft +
                    "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' +
                    theme.strings.next +
                    '">' +
                    theme.icons.chevronRight +
                    "</button>",
                  customPaging: function e(a, n) {
                    return (
                      '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" />' +
                      '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(
                        i + t,
                        'ms" />'
                      ) +
                      "</svg></button>"
                    );
                  },
                  rtl: !!document.querySelector("html[dir=rtl]"),
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: !1,
                        dots: "none" !== $(this).data("navigation"),
                      },
                    },
                  ],
                })
                .on("beforeChange", function (e, t, i) {
                  ("slide_fade" === $(this).data("transition") ||
                    "zoom" === $(this).data("transition")) &&
                    $(t.$slides.get(i)).addClass("slick--leaving");
                })
                .on("afterChange", function (e, t) {
                  $(t.$slides)
                    .filter(".slick--leaving")
                    .removeClass("slick--leaving");
                });
          }),
            $(".overlay-text__title, .overlay-text__rte", t).each(function () {
              theme.avoidUnecessaryOrphans(this);
            });
        }),
        (this.onSectionUnload = function (e) {
          $(".slick-slider", e).slick("unslick").off("init"),
            $(window).off(".slideshowSection");
        }),
        (this.onBlockSelect = function (e) {
          $(e)
            .closest(".slick-slider")
            .slick("slickGoTo", $(e).data("slick-index"))
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (e) {
          $(e).closest(".slick-slider").slick("slickPlay");
        });
    })()),
    (theme.TestimonialsSection = new (function () {
      (this.onSectionLoad = function (e) {
        (this.namespace = theme.namespaceFromSection(e)),
          (this.$testimonialContainer = $(".testimonial-list", e)),
          this.$testimonialContainer
            .find(".testimonial-list__inner")
            .on("init", function () {
              $(".lazyload--manual", this)
                .removeClass("lazyload--manual")
                .addClass("lazyload");
            })
            .slick({
              fade: this.$testimonialContainer.hasClass(
                "testimonial-list--with-images"
              ),
              slidesToShow: this.$testimonialContainer.hasClass(
                "testimonial-list--without-images"
              )
                ? 2
                : 1,
              autoplay: this.$testimonialContainer.data("autoplay"),
              autoplaySpeed: this.$testimonialContainer.data("autoplay-speed"),
              dots: !1,
              arrows: !0,
              appendArrows: this.$testimonialContainer.find(
                ".testimonial-list__controls"
              ),
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' +
                theme.strings.previous +
                '">' +
                theme.icons.chevronLeft +
                "</button>",
              nextArrow:
                '<button type="button" class="slick-next" aria-label="' +
                theme.strings.next +
                '">' +
                theme.icons.chevronRight +
                "</button>",
              rtl: !!document.querySelector("html[dir=rtl]"),
              responsive: [
                { breakpoint: 768, settings: { fade: !1, slidesToShow: 1 } },
              ],
            });
      }),
        (this.onSectionUnload = function (e) {
          $(".slick-slider", e).each(function () {
            $(this).slick("unslick").off("init");
          });
        }),
        (this.onBlockSelect = function (e) {
          var t = $(e).data("slick-index");
          $(e)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", t);
            });
        });
    })()),
    $(function (e) {
      var e = e;
      e(document).on("keyup.themeTabCheck", function (t) {
        9 === t.keyCode &&
          (e("body").addClass("tab-used"),
          e(document).off("keyup.themeTabCheck"));
      }),
        e(document).on("click", "a[data-toggle-target]", function (t) {
          t.preventDefault();
          var i = e(this),
            a = e(e(this).data("toggle-target")),
            n = a.find(".toggle-target-container"),
            o = !a.hasClass("toggle-target--hidden"),
            s =
              a.css("transition-duration").indexOf("ms") >= 0
                ? parseInt(a.css("transition-duration"))
                : 1e3 * parseFloat(a.css("transition-duration"));
          a.hasClass("toggle-target--in-transition") ||
            (o
              ? (i.addClass("toggle-target-toggler--is-hidden"),
                a
                  .addClass(
                    "toggle-target--in-transition toggle-target--hiding"
                  )
                  .css({ height: n.outerHeight() + "px", opacity: 1 }),
                setTimeout(function () {
                  a.css({ height: 0, opacity: 0 }),
                    setTimeout(function () {
                      a
                        .addClass("toggle-target--hidden")
                        .removeClass(
                          "toggle-target--in-transition toggle-target--hiding"
                        ),
                        a.css({ height: "", opacity: "" });
                    }, s);
                }, 10))
              : (i.removeClass("toggle-target-toggler--is-hidden"),
                a
                  .addClass(
                    "toggle-target--in-transition toggle-target--revealing"
                  )
                  .css({ height: 0, opacity: 0, display: "block" }),
                setTimeout(function () {
                  a.css({ height: n.outerHeight() + "px", opacity: 1 }),
                    setTimeout(function () {
                      a.removeClass(
                        "toggle-target--hidden toggle-target--in-transition toggle-target--revealing"
                      ),
                        a.css({ height: "", opacity: "", display: "" });
                    }, s);
                }, 10)));
        }),
        e(document).on("change", "select.navdrop", function () {
          window.location = e(this).val();
        }),
        e(document).on("click", ".mobile-nav-toggle", function (t) {
          t.preventDefault(),
            e("body").hasClass("enable-mobile-nav-transition")
              ? (e("body").removeClass(
                  "reveal-mobile-nav reveal-mobile-nav--revealed"
                ),
                setTimeout(function () {
                  e("body").removeClass("enable-mobile-nav-transition");
                }, 750))
              : theme.openMobileNav();
        }),
        (theme.openMobileNav = function () {
          e("body").addClass("enable-mobile-nav-transition"),
            setTimeout(function () {
              e("body").addClass("reveal-mobile-nav"),
                e(".mobile-navigation-drawer .disclosure").each(function () {
                  var t = e(".disclosure-list", this),
                    i = 0;
                  t.children().each(function () {
                    i += e(this).height();
                  }),
                    e(".disclosure-list", this).css("height", i + "px");
                }),
                e(".mobile-navigation-drawer .lazyload--manual")
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
                e(".mobile-navigation-drawer .product-list").each(function () {
                  theme.ProductBlockManager.loadImages(e(this));
                });
              var t = e(
                  ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
                ).css("transition-delay"),
                i = e(
                  ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
                ).css("transition-duration"),
                a = parseFloat(t.split(",")[0]) + parseFloat(i.split(",")[0]);
              setTimeout(function () {
                e("body").addClass("reveal-mobile-nav--revealed");
              }, 1e3 * a);
            }, 10);
        }),
        e(
          '<a href="#" class="page-shade" aria-label="' +
            theme.strings.general_navigation_menu_toggle_aria_label +
            '"></a>'
        )
          .on("click", function () {
            return (
              e("body").removeClass("reveal-mobile-nav show-search"),
              setTimeout(function () {
                e("body").removeClass("enable-mobile-nav-transition");
              }, 750),
              !1
            );
          })
          .appendTo("body"),
        "off" != theme.settings.quickbuy_style && theme.loadQuickbuy(),
        e(document).on("load-product-form", ".product-form", function (t) {
          if ("" !== e(this).data("product-id")) {
            var i = e(this),
              a = e(this).closest(".product-detail");
            e(this).on("variantChanged", function (t, i, n) {
              var o = a.find(".product-label-list");
              o.find(".product-label-container").remove(),
                i
                  ? o.append(
                      e("#variant-label-".concat(n.id, "-").concat(i.id)).html()
                    )
                  : o.append(e("#variant-label-".concat(n.id, "-none")).html()),
                i &&
                  a.find(".dynamic-payment-button-template").each(function () {
                    e(this).after(e(this).html()).remove(),
                      Shopify.PaymentButton && Shopify.PaymentButton.init();
                  });
            });
            var n,
              o = a.find(".option-selector--swatch");
            o.length &&
              e("body.swatch-style-icon_circle, body.swatch-style-icon_square")
                .length &&
              (o.find(".label").append('<span class="label__value">'),
              e(this).on("variantChanged", function (t, i) {
                o.each(function () {
                  var t = e(this).data("option-index");
                  if (i) {
                    var a = i.options[t];
                    e(this).find(".label__value").text(a);
                  } else {
                    var n = this.querySelector(".opt-btn:checked");
                    n && e(this).find(".label__value").text(n.value);
                  }
                });
              })),
              a.find('.option-selectors[data-disable-unavailable="true"]')
                .length &&
                e(this).on("variantChanged", function (t, i) {
                  var a = this,
                    n = theme.OptionManager.getProductData(e(this)),
                    o = [],
                    s = [];
                  e(
                    '.option-selectors[data-disable-unavailable="true"] .option-selector',
                    this
                  ).each(function (t) {
                    var i = e(this).find("input:checked"),
                      a = e(this).find(
                        '.cc-select__option[aria-selected="true"]'
                      ),
                      n = i.length ? i.val() : a ? a.data("value") : null;
                    s.push(n);
                  });
                  for (var r = 0; r < n.options.length; r++) {
                    for (
                      var l = n.options[r], c = {}, d = 0;
                      d < n.variants.length;
                      d++
                    ) {
                      var h = n.variants[d];
                      c[h.options[r]] || (c[h.options[r]] = !1);
                    }
                    o.push({ name: l, values: c });
                  }
                  for (
                    var u = function e(t) {
                        n.options[t];
                        for (var i = [], a = 0; a < s.length && a < t; a++)
                          i.push(s[a]);
                        Object.keys(o[t].values).forEach((e) => {
                          var a = i.map((e) => e);
                          a.push(e);
                          for (var s = !1, r = 0; r < n.variants.length; r++) {
                            for (
                              var l = n.variants[r], c = !0, d = 0;
                              d < a.length;
                              d++
                            )
                              a[d] && a[d] != l.options[d] && (c = !1);
                            c && l.available && (s = !0);
                          }
                          o[t].values[e] = s;
                        });
                      },
                      p = 0;
                    p < n.options.length;
                    p++
                  )
                    u(p);
                  for (var f = 0; f < o.length; f++) {
                    var m = function t(i) {
                      e(
                        '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                          f,
                          '"] .opt-btn'
                        ),
                        a
                      )
                        .filter(function () {
                          return this.value === i;
                        })
                        .toggleClass("is-unavailable", !o[f].values[i]),
                        e(
                          '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                            f,
                            '"] .cc-select__option'
                          ),
                          a
                        )
                          .filter(function () {
                            return this.dataset.value === i;
                          })
                          .toggleClass("is-unavailable", !o[f].values[i]);
                    };
                    for (var g in o[f].values) m(g);
                  }
                }),
              i.on("change", ".option-selector", function () {
                i.hasClass("product-form--validation-started") &&
                  theme.validateProductForm(i);
              }),
              theme.OptionManager.initProductOptions(e(this));
          }
        }),
        e(document).on("unload-product-form", ".product-form", function () {
          e(this).off("variantChanged change"),
            theme.OptionManager.unloadProductOptions(e(this));
        }),
        e(document).on("variantImageSelected", ".gallery", function (t, i, a) {
          var n = e(this),
            o = n
              .filter(
                ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2"
              )
              .find(".product-slideshow:not(.slick-slider)"),
            s = !1,
            r = null;
          if ("" !== n.attr("data-variant-image-grouping-option-index")) {
            var l = n.attr("data-variant-image-grouping-option-index"),
              c = i.options[l],
              d = n.find(".thumbnails");
            if ((r = n.find(".slideshow")).hasClass("slick-slider")) {
              var h = !!r.find(
                '.slide[data-media-id="'.concat(i.featured_media.id, '"]')
              ).length;
              r
                .slick("slickUnfilter")
                .slick(
                  "slickFilter",
                  '.slide[data-media-id="'
                    .concat(
                      i.featured_media.id,
                      '"], [data-variant-image-group="'
                    )
                    .concat(c.replace('"', "&quot;").replace(/<>/g, ""), '"]')
                ),
                r.find(".slide").css({
                  position: "",
                  left: "",
                  top: "",
                  zIndex: "",
                  opacity: "",
                }),
                h ||
                  (r.slick("slickGoTo", 0, !0),
                  r.slick(
                    "slickGoTo",
                    r
                      .find(
                        '.slide[data-media-id="'.concat(
                          i.featured_media.id,
                          '"]'
                        )
                      )
                      .data("slick-index"),
                    !0
                  ));
            }
            if (d.hasClass("owl-carousel")) {
              var u = n.find(".hidden-thumbnails");
              u.length ||
                (u = e('<div class="hidden-thumbnails hidden">').insertAfter(
                  d
                )),
                d
                  .find(".thumbnail")
                  .show()
                  .each(function () {
                    if (
                      e(this).attr("data-variant-image-group") != c &&
                      e(this).attr("data-media-id") != i.featured_media.id
                    ) {
                      var t = e(this).parent().index();
                      e(this).appendTo(u),
                        d.trigger("remove.owl.carousel", [t]);
                    }
                  }),
                u.find(".thumbnail").each(function () {
                  (e(this).attr("data-variant-image-group") == c ||
                    e(this).attr("data-media-id") == i.featured_media.id) &&
                    (e(this).show(), d.trigger("add.owl.carousel", [this]));
                }),
                d.trigger("refresh.owl.carousel");
            } else
              d.find(".thumbnail").each(function () {
                e(this).attr("data-variant-image-group") == c ||
                e(this).attr("data-media-id") == i.featured_media.id
                  ? e(this).show()
                  : e(this).hide();
              });
            o.length &&
              (o.find(".slide").each(function () {
                e(this).attr("data-variant-image-group") == c ||
                e(this).attr("data-media-id") == i.featured_media.id
                  ? (e(this).hasClass("slide--inactive-option") && (s = !0),
                    e(this).removeClass("slide--inactive-option"))
                  : (e(this).hasClass("slide--inactive-option") || (s = !0),
                    e(this).addClass("slide--inactive-option"));
              }),
              o.find(".slide--inactive-option").appendTo(o));
          }
          if (
            (n
              .find(
                '.thumbnails a[data-media-id="' +
                  i.featured_media.id +
                  '"]:first'
              )
              .trigger("select"),
            o.length)
          ) {
            var p = n.find(
              '.slide[data-media-id="' + i.featured_media.id + '"]:first'
            );
            p.length &&
              (a && !s
                ? theme.scrollToRevealElement(p[0])
                : s
                ? (n
                    .find(".slide--was-highlighted")
                    .removeClass("slide--was-highlighted"),
                  p.addClass("slide--was-highlighted"))
                : p.hasClass("slide--was-highlighted") ||
                  (clearTimeout(theme.variantImageFadeTimeout),
                  n
                    .find(".slide--highlight-on")
                    .removeClass("slide--highlight-on"),
                  n
                    .find(".slide--highlight-off")
                    .removeClass("slide--highlight-off"),
                  n
                    .find(".slide--was-highlighted")
                    .removeClass("slide--was-highlighted"),
                  p
                    .addClass("slide--highlight-on slide--was-highlighted")
                    .siblings()
                    .addClass("slide--highlight-off"),
                  (theme.variantImageFadeTimeout = setTimeout(function () {
                    n
                      .find(".slide--highlight-on")
                      .removeClass("slide--highlight-on"),
                      n
                        .find(".slide--highlight-off")
                        .removeClass("slide--highlight-off");
                  }, 1200)),
                  theme.scrollToRevealElement(p[0])));
          }
        }),
        e(document).on(
          "click",
          ".product-detail .gallery .main-image a.show-gallery",
          function () {
            var t = [],
              i = e(this)
                .closest(".product-slideshow")
                .find(".slide:not(.slide--inactive-option) .show-gallery"),
              a = e(this).attr("href");
            if (i.length)
              i.each(function () {
                var i = e(this).find(".rimage-outer-wrapper").clone();
                i
                  .find(".lazyloaded")
                  .removeClass("lazyloaded")
                  .addClass("lazyload")
                  .parent()
                  .addClass("lazyload--placeholder"),
                  t.push({ thumbTag: i, zoomUrl: e(this).attr("href") });
              });
            else {
              var n = e(this).find(".rimage-outer-wrapper").clone();
              n
                .find(".lazyloaded")
                .removeClass("lazyloaded")
                .addClass("lazyload")
                .parent()
                .addClass("lazyload--placeholder"),
                t.push({ thumbTag: n, zoomUrl: e(this).attr("href") });
            }
            return (
              theme.buildGalleryViewer({
                images: t,
                currentImage: a,
                prev: theme.icons.chevronLeft,
                next: theme.icons.chevronRight,
                close: theme.icons.close,
              }),
              !1
            );
          }
        );
      var t = e(".product-list, .collection-listing").filter(function () {
        return 0 == e(this).closest("[data-section-type]").length;
      });
      if (
        (t.length && theme.ProductBlockManager.loadImages(t),
        e(window).on("debouncedresize", function () {
          setTimeout(function () {
            theme.ProductBlockManager.afterImagesResized();
          }, 100);
        }),
        e("#template label").each(function () {
          var t = e(this).siblings('input:not([type="submit"]), textarea');
          1 == t.length &&
            t.attr("id").length > 0 &&
            e(this).attr("for", t.attr("id"));
        }),
        e(document).on(
          "click",
          ".quantity-wrapper [data-quantity]",
          function () {
            var t = "up" == e(this).data("quantity") ? 1 : -1,
              i = e(this).closest(".quantity-wrapper").find("[name=quantity]");
            return (
              i.attr("step") && (t *= parseInt(i.attr("step"))),
              i.val(Math.max(1, parseInt(i.val()) + t)).trigger("change"),
              !1
            );
          }
        ),
        e(".responsive-table").on(
          "click",
          ".responsive-table__cell-head",
          function () {
            if (768 > e(window).width())
              return e(this).closest("tr").toggleClass("expanded"), !1;
          }
        ),
        void 0 !== cc && cc.sections)
      )
        for (var i in cc.sections) {
          var a = cc.sections[i];
          if ("video" === a.name) {
            var n = a.section.onSectionLoad;
            a.section.onSectionLoad = function (t) {
              e(".overlay-text__title, .overlay-text__rte", t).each(
                function () {
                  theme.avoidUnecessaryOrphans(this);
                }
              ),
                n.call(this, t);
            };
          }
        }
      theme.Sections.init(),
        theme.Sections.register("header", theme.HeaderSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "announcement-bar",
          theme.AnnouncementBarSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("cart-drawer", theme.CartDrawerSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register(
          "image-with-text-overlay",
          theme.ImageWithTextOverlaySection
        ),
        theme.Sections.register(
          "featured-collection",
          theme.FeaturedCollectionSection
        ),
        theme.Sections.register(
          "featured-collections",
          theme.FeaturedCollectionsSection
        ),
        theme.Sections.register("map", theme.MapSection),
        theme.Sections.register("background-video", theme.VideoManager, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register("custom-row", theme.CustomRowSection),
        theme.Sections.register(
          "featured-product",
          theme.FeaturedProductSection
        ),
        theme.Sections.register(
          "scrolling-banner",
          theme.ScrollingBannerSection
        ),
        theme.Sections.register("main-product", theme.ProductTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "collection-template",
          theme.CollectionTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "search-template",
          theme.SearchTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("cart-template", theme.CartTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "page-list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("contact", new (function () {})());
    }),
    $(function (e) {
      cc.sections.length
        ? cc.sections.forEach((e) => {
            try {
              var t = {};
              void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad),
                void 0 !== e.deferredLoadViewportExcess &&
                  (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess),
                theme.Sections.register(e.name, e.section, t);
            } catch (i) {
              console.error(
                "Unable to register section ".concat(e.name, "."),
                i
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
})(theme.jQuery);
